const en = {
  startStopAdmin: {
    nRecords1: "{{n}} record",
    tNFields1: "{{n}} field",
    totMapF1: "road distance of {{n}} leg",
    tAttachTitle: "Attachments / photos",
    stStopped: "Completed",
    stStarted: "Started",
    stPending: "Pending",
    stMissing: "Pending · not done",
    allStatuses: "All statuses",
    allDepots: "All depots",
    allRoutes: "All routes",
    allEmployees: "All employees",
    clear: "Clear",
    search: "Search…",
    nRecords: "{{n}} records",
    noRecords: "No records",
    title: "Start-Stop Records",
    subtitle: "Click a row: locations, map, distances and photos",
    kTotal: "Total tours",
    kMissing: "Required, not done",
    kTimeChanged: "Time changed",
    kOdometer: "Odometer km",
    timeChanged: "Time was changed",
    thEmployee: "Employee",
    thDate: "Date",
    thStatus: "Status",
    thDuration: "Duration",
    details: "Details",
    corrShort: "corr.",
    loadFailed: "Could not load",
    resetDone: "Record reset",
    resetFailed: "Could not reset",
    dur: "{{h}}h {{m}}m",
    yes: "Yes",
    no: "No",
    lgStop: "Stops",
    lgRemaining: "Remaining stops",
    lgPackages: "Remaining parcels",
    lgPickup: "Pickup",
    lgNote: "Note",
    startKm: "Start km",
    endKm: "End km",
    startTime: "Start time",
    endTime: "End time",
    pToday: "Today",
    pYesterday: "Yesterday",
    pLast7: "Last 7 days",
    pThisWeek: "This week",
    pLastWeek: "Last week",
    pThisMonth: "This month",
    pLastMonth: "Last month",
    xDate: "Date",
    xEmployee: "Employee",
    xRoute: "Route",
    xDepot: "Depot",
    xStatus: "Status",
    xRequired: "Required",
    xStartTime: "Start time",
    xStartSent: "Start sent",
    xStartKm: "Start km",
    xStartAddr: "Start address",
    xStartCoord: "Start coordinates",
    xStopTime: "Stop time",
    xStopSent: "Stop sent",
    xStopKm: "Stop km",
    xStopAddr: "Stop address",
    xStopCoord: "Stop coordinates",
    xTotalKm: "Total km",
    xDuration: "Duration (min)",
    xCorrected: "Corrected",
    noStart: "No Start",
    noStop: "No Stop",
    completeStop: "Complete Stop",
    edit: "Edit",
    nextDay: "next day",
    byAdminCompleted: "Completed by admin",
    byAdminEdited: "Edited by admin",
    sentAt: "Sent {{time}} ({{diff}} min)",
    mapFailed: "Map could not be loaded",
    computing: "Calculating distances…",
    noCorrections: "No corrections",
    adminStopCompleted: "Admin · completed Stop",
    reason: "Reason",
    lat: "Latitude",
    lng: "Longitude",
    address: "Address",
    corrected: "corrected",
    nReminders: "{{n}} reminders",
    kmOdo: "{{km}} km odometer",
    windowClosed: "Stop time expired ({{at}}). The driver can no longer Stop; close it with \"Complete Stop\".",
    secRoute: "Route and distances",
    secFiles: "Photos & documents ({{n}})",
    none: "None",
    secCorrections: "Correction history",
    noDepotLoc: "No location set for <b>{{depot}}</b>. Edit the depot under Planning → Depots and add a location so Depot→Start and Stop→Depot distances can be calculated.",
    depot: "Depot",
    legDepotStart: "Depot → First Start",
    legOdo: "Start → Stop (odometer)",
    legOdoSub: "End km − Start km",
    onMap: "{{km}} km on map",
    legStopDepot: "Last Stop → Depot",
    road: "road distance",
    straight: "straight line (no road found)",
    aboutMin: "~{{m}} min",
    totOdo: "Total (odometer + ends)",
    totOdoF: "Depot→Start + odometer + Stop→Depot",
    totOdoOnly: "odometer only (no depot location)",
    totMap: "Total (all from map)",
    totMapF: "road distance of {{n}} legs",
    mapLayer: "Map / Satellite",
    satellite: "Satellite",
    map: "Map",
    fullscreen: "Full screen",
    exitFullscreen: "Exit full screen",
    pinDepot: "DEPOT",
    resetTitle: "Reset record",
    resetConfirmTitle: "Reset this record?",
    resetConfirmBody: "The Start-Stop record, its photos and corrections will be deleted; the employee can Start/Stop again. This cannot be undone.",
    cancel: "Cancel",
    resetYes: "Yes, reset",
    remBtn: "Reminders",
    remTitle: "Start-Stop reminders",
    remDesc: "Drivers who haven't pressed Start or Stop get a phone notification (push).",
    remLoadFailed: "Settings could not be loaded",
    remSaved: "Reminder settings saved",
    remInvalid: "Check the values (hours 1–24, repeat 15–360 min)",
    saveFailed: "Could not save",
    remEnabled: "Reminders on",
    remHours: "Hours after Start",
    remHoursDesc: "First notification is sent when this time passes without Stop",
    hours: "hours",
    min: "min",
    remRepeat: "Remind once more",
    remRepeatDesc: "Second notification if still no Stop",
    remSecond: "Second reminder",
    remSecondDesc: "Minutes after the first",
    remAdmins: "Summary to admins",
    remAdminsDesc: "After the last reminder, company admins get a list of who didn't Stop",
    remEvery: "Checked every 5 minutes.",
    save: "Save",
    saving: "Saving…",
    locInvalid: "Location must be \"latitude, longitude\"",
    endTimeRequired: "End time is required",
    reasonMin: "Enter a reason (at least 3 characters)",
    stopCompleted: "Stop completed",
    recordCorrected: "Record corrected",
    editTitleStart: "Edit Start data",
    editTitleStop: "Edit Stop data",
    editDesc: "Old and new values are logged in the history.",
    locLabel: "Location (latitude, longitude)",
    reasonLabel: "Reason *",
    reasonPh: "e.g. Driver forgot to Stop, confirmed by phone",
    complete: "Complete",
    tSsMode: "Start-Stop mode",
    tSsModeDesc: "A big Start button appears on the employee's dashboard; the tour ends with Stop. Choose below which form fields are asked at Start and which at Stop.",
    tRequired: "Required",
    tRequiredDesc: "The form cannot be sent without Start/Stop; those who skip it show in red on the Start-Stop Records page.",
    tHideForm: "Hide remaining form fields",
    tHideFormDesc: "Checked: only the Start/Stop screens are asked. Unchecked: fields left 'In form' are filled in a separate form.",
    tHideRouteReport: "Hide old \"Report route\" form",
    tHideRouteReportDesc: "Checked: drivers planned on this template no longer see the old \"Report route\" button, only Start/Stop.",
    tWindow: "Start-Stop time window",
    tWindowStart: "Start opens",
    tWindowEnd: "Stop deadline",
    tOvernight: "next day · night tour",
    tClear: "clear",
    tWindowSet: "The driver can Start/Stop from {{ws}} on the assignment day until {{nd}}{{we}}. After that, an admin completes open tours.",
    tNextDayPrefix: "the next day ",
    tWindowEmpty: "Empty: assignment day 00:00–24:00. For night tours enter e.g. 20:00 → 10:00 (an earlier end counts as next day).",
    pFillDepot: "Fill depot coordinates",
    pUsesDepot: "If empty, the depot coordinates are used ({{c}})",
    pOpenMap: "Open in map",
    pPointLabelPh: "e.g. Customer depot Genk",
    pPointLabel: "Location name (shown to driver)",
    pCoordsInvalid: "Invalid format. Example: 51.17452,5.82870",
    pCoords: "Start coordinates (lat,lng)",
    simToStart: "Driving depot → Start",
    simTour: "On tour (delivery)",
    simBack: "Returning to depot",
    simAtDepot: "Back at depot",
    simReset: "Rewind",
    nMin: "{{m}} min",
    departDepot: "Depot departure",
    returnDepot: "Depot return",
    workTotal: "Total work time",
    workFormula: "Depot departure (Start − depot→Start drive) → depot return (Stop + Stop→depot drive)",
    workEstimated: "Drive times partly estimated (routing service unavailable)",
    workNoDepot: "No depot coordinates — Start→Stop time only",
    nfStart: "Start reminder",
    nfClose: "Stop deadline: {{m}} min left",
    nfOverdue: "Overdue Stop reminder",
    noNotifs: "No notifications sent yet",
    secNotifs: "Notification history ({{n}})",
    workShort: "Total {{d}}",
    thWork: "Total work",
    kWork: "Total work time",
    kWorkAvg: "Avg. {{d}} · tours: {{n}}",
    kWorkNone: "No completed tours",
    pTitle: "Fixed start time and location",
    pDesc: "The employee only enters the km and taps Start; time and location come from here and cannot be changed.",
    pDefaultTime: "Depot default time",
    pDefaultTimeCompany: "Default time",
    pRouteTimes: "Start time per tour",
    pUsesDefault: "default {{time}}",
    pFree: "free",
    pLocation: "Fixed start location (e.g. customer depot)",
    pLocationDesc: "This location is recorded at Start; the phone location is kept as backup/log. Start works even without location.",
    pNoCoords: "No coordinates entered and the depot has none — the phone location is used.",
    pHint: "For tours without a time the employee enters it. Reminders: 5 times during the Start window, and 60/30/10 min before the Stop deadline.",
    presetTimeBadge: "Fixed time · tapped {{time}}",
    presetLocBadge: "Fixed start location",
    deviceLoc: "Phone location (backup)",
    deviceLocNone: "Phone location unavailable",
    remStartPrompts: "Start reminder (5 times)",
    remStartPromptsDesc: "If not started, evenly spaced from window opening to start time",
    remClose: "Stop deadline reminder",
    remCloseDesc: "If not stopped, 60, 30 and 10 min before the deadline",
    tAskStart: "Asked at Start",
    tAskStop: "Asked at Stop",
    tNFields: "{{n}} fields",
    tAutoLoc: "Location and time are always captured automatically",
    tNoFields: "No fields yet",
    tUnnamed: "(unnamed)",
    tKmPhoto: "KM + photo",
    tKmPhotoTitle: "The employee types the km and can optionally photograph the odometer",
    tRemoveFromPhase: "Remove from this phase (back to form)",
    tAttachMulti: "(multiple)",
    tShow: "Show",
    tAddKm: "Add {{label}} (type or photo)",
    tPickExisting: "+ Pick an existing form field…",
    tNewField: "Add new field",
    tFieldNamePh: "Field name (e.g. Stop count)",
    tAdd: "Add",
    tAllFields: "All form fields — where should they be asked?",
    tInForm: "In form",
    tTimeLocked: "Time is captured automatically on the Start/Stop screen",
    tHint: "A field is asked in only one place. For a KM field moved to Start/Stop, the employee types the km and can optionally photograph the odometer. Time fields can't be moved; Start/Stop captures the time itself.",
    tAtStart: "At Start",
    tAtStop: "At Stop",
    ty_text: "Text",
    ty_number: "Number",
    ty_time: "Time",
    ty_date: "Date",
    ty_photo: "Photo",
    ty_boolean: "Yes/No",
    ty_select: "Choice",
  },
  startStop: {
    todayBadge: "TODAY",
    tomorrowBadge: "TOMORROW",
    afterStop: "After Stop",
    overnight: "Last night's tour · Stop deadline {{time}}",
    overnightBadge: "LAST NIGHT",
    startOpensAt: "Start opens at {{time}}",
    stopDeadline: "Stop deadline {{time}}",
    nextDay: "(next day)",
    windowClosed: "Start-Stop time has expired",
    closedManagerCompletes: "Your manager will complete your tour.",
    closedInformManager: "Please inform your manager.",
    startTour: "Start tour",
    required: "required",
    running: "Tour in progress",
    startLabel: "Start",
    startKmShort: "Start km",
    photo: "photo",
    finished: "Tour completed",
    correctionUsed: "Correction already used",
    correctLast: "Correct last entries (1 time)",
    elapsed: "{{h}} h {{m}} min",
    yes: "Yes",
    no: "No",
    saveFailed: "Could not save",
    optional: "(optional)",
    noLocStart: "Cannot start without location",
    noLocStop: "Cannot finish without location",
    orPhoto: "(or photo)",
    missing: "Missing: {{list}}",
    startKm: "Start km",
    endKm: "End km",
    startTime: "Start time",
    endTime: "End time",
    timeHint: "If you change it, the actual send time is also recorded",
    kmHintStart: "Type it or photograph the odometer with the camera on the right",
    kmHintStop: "Type it or photograph the odometer with the camera",
    startedTitle: "Tour started",
    goodWork: "Have a good shift!",
    canClose: "You can close this screen. When the tour ends, tap STOP here.",
    startTitle: "Start Tour",
    takePhoto: "Take photo",
    addFile: "Add file",
    attachments: "Attachments",
    attachmentsPhotos: "Attachments / photos",
    endKmLess: "End km cannot be less than start ({{km}})",
    filesUploading: "Files are uploading, please wait",
    savedThanks: "Operation saved, thank you!",
    totalKm: "Total {{km}} km",
    recordReceived: "Record received",
    oneCorrection: "If you entered something wrong, you can correct it once.",
    stopTitle: "Finish Tour",
    stopSave: "STOP · Save",
    reasonRequired: "Enter the reason for the correction",
    noChange: "No changes",
    correctionSaved: "Correction saved",
    correctTitle: "Correct last entries",
    correctSubtitle: "You have one correction; it is logged",
    saveCorrection: "Save correction",
    correctionReason: "Reason for correction *",
    reasonPlaceholder: "e.g. km typed wrong",
    okClose: "OK, close screen",
    geoUnsupported: "Your device does not support location",
    geoDenied: "Location permission denied. Allow location for this site in your browser settings and try again.",
    geoFailed: "Could not get location. Try again outdoors.",
    geoOk: "Location received",
    presetLocation: "Start location: {{depot}} (preset)",
    presetTimeHint: "Start time is set by your manager",
    refresh: "Refresh",
    geoRetry: "Retry location",
    geoLoading: "Getting location… tap \"Allow\" if asked",
    kmPhotoUploaded: "Odometer photo uploaded",
    photoUploadFailed: "Photo upload failed",
    kmPlaceholder: "e.g. 125430",
    kmPhotoTitle: "Take odometer photo",
    now: "Now",
    photoAdded: "Photo added · change",
    takePhotoFull: "Take photo",
    geoModalTitle: "We couldn't get your location",
    geoWaiting: "Waiting for location…",
    geoRequired: "Start / Stop cannot be sent without location.",
    gettingLocation: "Getting location…",
    retry: "Try again",
    close: "Close",
    overdueTitle: "Did you forget to Stop?",
    overdueBody: "Your tour has been open for {{h}} hours. If you're done, tap Stop now.",
    stepsDeniedIos: ["Settings → Privacy → Location Services must be on", "Settings → Safari (or the app) → Location → \"Ask\" or \"Allow\"", "Come back to this page and tap \"Try again\""],
    stepsDeniedAndroid: ["Tap the lock icon in the address bar", "Permissions → Location → \"Allow\"", "Make sure the phone's location (GPS) is on, then \"Try again\""],
    stepsOther: ["Make sure the phone's location (GPS) is on", "If you're indoors, go outside", "Tap \"Try again\""],
  },
  common: {
    welcome: "Welcome",
    login: "Login",
    register: "Register",
    logout: "Logout",
    dashboard: "Dashboard",
    profile: "Profile",
    settings: "Settings",
    security: "Security",
    users: "Users",
    firms: "Firms",
    save: "Save",
    cancel: "Cancel",
    delete: "Delete",
    edit: "Edit",
    create: "Create",
    yes: "Yes",
    no: "No",
    clear: "Clear",
    clearAll: "Clear All",
    optional: "optional",
    approve: "Approve",
    reject: "Reject",
    pending: "Pending",
    active: "Active",
    rejected: "Rejected",
    search: "Search",
    year: "Year",
    month: "Month",
    day: "Day",
    unknown: "Unknown",
    firmDistribution: "Firm Distribution",
    loading: "Loading...",
    error: "Error",
    success: "Success",
    back: "Back",
    next: "Next",
    submit: "Submit",
    actions: "Actions",
    noData: "No data found",
    confirmDelete: "Are you sure you want to delete?",
    auditLogs: "Audit Logs",
    leaveRequests: "Leave Requests",
    confirm: "Confirm",
    confirmation: "Confirmation",
    all: "All",
    firm: "Firm",
    refresh: "Refresh",
    total: "Total",
    email: "Email Address",
    language: "Language",
    filters: "Filters",
    clearFilters: "Clear",
    more: "more",
    refreshed: "Refreshed",
    processing: "Processing...",
    from: "From",
    to: "To",
    name: "Name",
    status: "Status",
    type: "Type",
    date: "Date",
    amount: "Amount",
    description: "Description",
    details: "Details",
    view: "View",
    download: "Download",
    upload: "Upload",
    add: "Add",
    remove: "Remove",
    select: "Select",
    selected: "Selected",
    none: "None",
    period: "Period",
    collapseMenu: "Collapse Menu",
    expandMenu: "Expand Menu",
    darkMode: "Dark Mode",
    lightMode: "Light Mode",
    colorTheme: "Color Theme",
    clearFilter: "Clear Filter",
    close: "Close",
    dateRange: "Date Range",
    filter: "Filter",
    globalSearch: "Search employee or plate...",
    lastMonth: "Last Month",
    noResults: "No results found",
    page: "Page",
    perPage: "per page",
    previous: "Previous",
    records: "records",
    show: "Show",
    showing: "Showing",
    vehicleBadge: "Vehicle",
    unassigned: "Unassigned",
    allFirms: "All Firms",
    selectFirm: "Select firm",
    accessDenied: "Access Denied",
    document: "Document",
    inactive: "Inactive",
    saving: "Saving...",
    sending: "Sending...",
    deselectAll: "Deselect All",
    minutes: "min",
    selectAll: "Select All",
    allDepos: "All Depots",
    noDepo: "No Depot",
    reset: "Reset",
    showSold: "Show sold",
    sold: "SOLD",
    saleDate: "Sale Date",
    saleDateHint: "If sale date is set, vehicle is considered sold and hidden from lists",
    inVehicle: "In vehicle",
    outVehicle: "Out of vehicle",
    purchaseDate: "Purchase Date",
    saved: "Saved",
    addNote: "Add Note",
    noFilterResults: "No employees found for the selected filters",
    startDate: "Start",
    endDate: "End",
  },
  imageCropper: {
    title: "Edit Image",
    dragDrop: "Drag and drop image here",
    or: "or",
    selectFile: "Select File",
    paste: "Paste",
    pasteHint: "You can paste from clipboard with Ctrl+V",
    changeImage: "Change Image",
    zoom: "Zoom",
    rotate: "Rotate",
    preview: "Preview",
    reset: "Reset",
    upload: "Upload",
  },
  documentEditor: {
    dragDropTitle: "Drag and drop document here",
    supportedFormats: "JPG, PNG, WEBP, PDF supported",
    selectFile: "Select File",
    pasteFromClipboard: "Paste from Clipboard",
    pasteHint: "You can paste directly from clipboard with Ctrl+V",
    rotateLeft: "Rotate Left",
    rotateRight: "Rotate Right",
    flipHorizontal: "Flip Horizontal",
    flipVertical: "Flip Vertical",
    reset: "Reset",
    changeImage: "Change Image",
    skipEdit: "Upload Without Editing",
    cropAndUpload: "Crop and Upload",
    deleteConfirm: "Are you sure you want to delete this document?",
    deleteDocument: "Delete Document",
    deleteSuccess: "Document deleted",
    processing: "Processing...",
    save: "Save",
    saveAndUpload: "Save and Upload",
  },
  nav: {
    lockedDates: "Locked Dates",
    mailArchive: "Mail Archive",
    frontendSettings: "Frontend Settings",
    siteSettings: "Site Settings",
    myDocuments: "My Documents",
    myPayslips: "My Payslips",
    myPackages: "My Packages",
    myFinance: "My Finances",
    personalMenu: "Personal",
    myNotifications: "My Notifications",
    documentManagement: "Document Management",
    docManagement: "Documents",
    loonbrief: "Payroll Upload",
    loonbriefList: "Payroll List",
    pdfUpload: "PDF Upload",
    sendNotification: "Send Notification",
    routes: "Routes",
    allRoutes: "All Routes",
    routeReports: "Route Reports",
    fuelReports: "Fuel Report",
    vehicles: "My Vehicles",
    allUsers: "All Users",
    languages: "Languages",
    databaseBackup: "Database Backup",
    postnlCodes: "PostNL Codes",
    planning: "Planning",
    messages: "Messages",
    chat: "Chat",
    todoList: "To-Do List",
    communication: "Communication",
    dpd: "DPD",
    dpdDailySummary: "DPD Daily Summary",
    dpdDriverPerformance: "DPD Driver Performance",
    dpdConsolidated: "DPD Consolidated Report",
    dpdMonthlyInvoice: "DPD Monthly Invoice",
    dpdRetourHeatmap: "DPD Retour Heatmap",
    dpdSubcoComparison: "DPD Subco Comparison",
    dpdCourierMapping: "DPD Courier Mapping",
    dpdRetourReport: "DPD Retour Report",
    dpdFileCategories: "DPD File Categories",
    dpdAnalytics: "DPD Analytics & Insights",
  },
  fields: {
    firm_id: "Firm Selection",
    date: "Date",
    route_number: "Route Number",
    route_type: "Route Type",
    rit: "Rit",
    vehicle_plate: "Vehicle Plate",
    driver: "Driver",
    copilot: "Copilot",
    km_start: "KM Start",
    km_end: "KM End",
    stops: "Stops",
    stop_price: "Stop Price",
    hourly_rate: "Hourly Rate (€)",
    start_cost: "Start Cost (€)",
    start_time: "Start Time",
    end_time: "End Time",
    break_time: "Break Time",
    totaal_excl_btw: "Total excl VAT",
  },
  calcTypes: {
    hours_rate: "Hours × Rate + Start Cost",
    stops_price: "Stops × Stop Price",
    fixed_rate: "Fixed Rate + Start Cost",
    manual_total: "Start Cost = Total",
  },
  fuelReports: {
    title: "Fuel Day Report",
    subtitle: "Fuel Report",
    date: "Date",
    plate: "License Plate",
    tankCard: "Tank Card",
    driver: "Driver",
    liters: "Liters",
    pricePerLiter: "€/Liter",
    total: "Total",
    period: "Period",
    totalRecords: "Records",
    totalLiters: "Total Liters",
    totalCost: "Total Cost",
    searchPlaceholder: "Search driver, plate or tank card...",
    add: "New Fuel Record",
    edit: "Edit Fuel Record",
    importTitle: "Import from Excel",
    startDate: "Start Date",
    endDate: "End Date",
    notes: "Notes",
    attachments: "Attachments",
    loadError: "Could not load data",
    dateAndPlateRequired: "Date and plate are required",
    updated: "Updated",
    added: "Added",
    errorOccurred: "An error occurred",
    operationFailed: "Operation failed",
    deleted: "Deleted",
    cannotDelete: "Could not delete",
    fileAndFirmRequired: "File and firm selection are required",
    importSuccess: "{{count}} records imported",
    importFailed: "Import failed",
    fileUploaded: "File uploaded",
    uploadFailed: "Upload failed",
    fileDeleted: "File deleted",
    fileTooLarge: "Cannot exceed 10MB",
    fileUploadFailed: "could not be uploaded",
    excelImport: "Excel Import",
    selectDriver: "Select driver",
    searchDriver: "Search and select driver...",
    selectFirmFirst: "Select firm first",
    searchDriverPlaceholder: "Search driver...",
    driverNotFound: "Driver not found",
    manualEntry: "or enter manually",
    servicePartner: "Service Partner",
    clone: "Clone",
    cloned: "Record cloned with current date",
    noRecords: "No records found",
    deleteConfirm: "Are you sure you want to delete this record?",
    matched: "Matched",
    selectPlate: "Select plate",
    searchPlate: "Search plate...",
    plateNotFound: "Plate not found",
    addFile: "Add file",
    noAttachments: "No attachments",
    importing: "Importing...",
    import: "Import",
    manualDriverEntry: "or enter driver name",
    dragDropFiles: "Drag files or click to upload",
    delete: "Delete",
  },
  loonbrief: {
    title: "Payroll Upload",
    description: "Automatically distribute payroll PDFs to employees",
    uploadSettings: "Upload Settings",
    firm: "Firm",
    firmRequired: "Firm *",
    selectFirm: "Select firm...",
    period: "Period",
    periodRequired: "Period *",
    selectPeriod: "Select period...",
    pdfUpload: "Upload PDF",
    selectFirmFirst: "Please select a firm first",
    selectPeriodFirst: "Please select a period",
    processing: "Processing PDF, please wait...",
    processSuccess: "PDF processed",
    processError: "Error processing PDF",
    matched: "matched",
    unmatched: "unmatched",
    results: "Processing Results",
    page: "Page",
    nameFromPdf: "Name from PDF",
    matchedEmployee: "Matched Employee",
    status: "Status",
    action: "Action",
    statusMatched: "Matched",
    statusUnmatched: "Unmatched",
    statusError: "Error",
    manualMatch: "Manual Match",
    manualMatchTitle: "Manual Match",
    nameInPdf: "Name in PDF:",
    searchEmployee: "Search employee...",
    employeeNotFound: "Employee not found",
    matchSuccess: "matched with",
    aliases: "Aliases",
    naam: "Naam",
    clear: "Clear",
    saveMatched: "Save Matched",
    noMatchedToSave: "No matched payrolls to save",
    pdfNotFound: "PDF file not found, please upload again",
    saveSuccess: "payrolls saved successfully",
    savePartialError: "payrolls could not be saved",
    saveError: "Error saving",
    employeesLoaded: "employees loaded",
    employeesWithAliases: "employees have aliases defined",
    cancel: "Cancel",
    saveSummaryTitle: "Save Results",
    saveSummaryDesc: "Payroll saving process completed.",
    summarySaved: "Saved",
    summaryErrors: "Errors",
    summaryUnmatched: "Unmatched",
    summarySuccessTitle: "Successfully Saved Payrolls",
    summaryErrorTitle: "Failed Records",
    summaryUnmatchedTitle: "Unmatched Employees",
    summaryUpdated: "Updated",
    unmatchedHint: "These employees may not be registered in the system or their names may be in a different format. You can use manual matching.",
    close: "Close",
  },
  languages: {
    subtitle: "Edit system translations",
    syncComplete: "Synchronization complete!",
    syncCompleteDesc: "{added} new added, {updated} updated, {skipped} skipped",
    syncFailed: "Synchronization failed",
    translationSaved: "Translation saved to database",
    translationSaveFailed: "Failed to save translation",
    keyNameRequired: "Key name is required",
    keyAlreadyExists: "This key already exists",
    atLeastOneValue: "Enter at least one translation value",
    newKeyAdded: "New translation key added",
    addKeyFailed: "Failed to add translation",
    exported: "Translations exported",
    invalidFileFormat: "Invalid file format. JSON file must have {tr: {...}, en: {...}, ...} structure",
    analysisFailed: "File analysis failed",
    invalidJson: "Invalid JSON file",
    importComplete: "Import complete!",
    importCompleteDesc: "{added} new, {updated} updated, {skipped} skipped",
    importFailed: "Import failed",
    cacheCleared: "Cache cleared, reverted to default translations",
    translationsTab: "Translations",
    scanTab: "Missing Detection",
    scanTitle: "Missing Translation Key Detection",
    scanDescription: "Detects translation keys used in source code but not defined, and cross-language gaps.",
    scanBtn: "Start Scan",
    scanning: "Scanning...",
    scanComplete: "Scan complete",
    scanFailed: "Scan failed",
    scanKeysScanned: "Scanned in Code",
    scanKeysDefined: "Defined in i18n",
    scanUndefined: "Undefined Key",
    scanCrossLang: "Cross-Language Gap",
    scanSearchPlaceholder: "Search key...",
    allLanguages: "All Languages",
    undefinedInCode: "Keys Used in Code but Not Defined",
    undefinedInCodeDesc: "These keys are called with t() in source code but not defined in any language.",
    crossLangMissing: "Cross-Language Missing Keys",
    crossLangMissingDesc: "These keys are defined in some languages but missing in others.",
    missingInLangs: "Missing In",
    presentInLangs: "Present In",
    allKeysComplete: "All Keys Complete!",
    allKeysCompleteDesc: "All translation keys used in code are defined in all languages.",
    scanPrompt: "Start a scan to detect missing translation keys",
    scanPromptDesc: "Source code files will be scanned and compared with i18n definitions.",
    scanningInProgress: "Scanning source code...",
    synced: "Synced",
    syncToDb: "Sync to DB",
    newKey: "New Key",
    export: "Export",
    analyzing: "Analyzing...",
    import: "Import",
    reset: "Reset",
    missing: "missing",
    complete: "Complete",
    filteringMissing: "Filtering missing translations...",
    searchPlaceholder: "Search key or value...",
    selectNamespace: "Select namespace",
    allNamespaces: "All Namespaces",
    perPageSuffix: "/ page",
    allMissing: "All Missing",
    clearFilter: "Clear Filter",
    translationsTitle: "Translations",
    translationsFound: "translations found",
    missingFor: "missing",
    allMissingLabel: "All missing",
    keyColumn: "Key",
    actionColumn: "Action",
    missingValue: "(missing)",
    noResults: "No results found",
    pageLabel: "Page",
    editTitle: "Edit Translation",
    missingBadge: "Missing",
    translationPlaceholder: "translation...",
    cancel: "Cancel",
    saving: "Saving...",
    save: "Save",
    addTitle: "Add New Translation Key",
    addDescription: "Key format: namespace.key (e.g.: common.newFeature)",
    keyName: "Key Name",
    keyPlaceholder: "e.g.: common.addFinancialRecord",
    translationValues: "Translation Values",
    adding: "Adding...",
    add: "Add",
    importPreviewTitle: "Import Preview",
    importPreviewDesc: "File analyzed. The following changes will be made:",
    willAdd: "Will Add",
    willUpdate: "Will Update",
    totalKeys: "Total Keys",
    importMode: "Import Mode:",
    modeMerge: "Merge (Recommended)",
    modeSkip: "Skip Existing",
    modeOverwrite: "Overwrite",
    modeMergeDesc: "Existing values are preserved, new values are added/updated",
    modeSkipDesc: "Only new keys are added, existing ones remain unchanged",
    modeOverwriteDesc: "All values are replaced with the file content",
    keysAlreadyExist: "keys already exist",
    keysAlreadyExistDesc: "These keys will be updated.",
    protectExisting: "mode to preserve existing values.",
    newKeysToAdd: "New Keys to Add",
    andMoreKeys: "... and {count} more keys",
    keysToUpdate: "Keys to Update",
    existingToNew: "Current → New values",
    importing: "Importing...",
    syncTitle: "Sync Translations to Database",
    syncDesc: "Transfer all translations from i18n.js to MongoDB database. This only adds missing keys and preserves your edits.",
    inI18n: "In i18n.js",
    inDb: "In Database",
    toBeAdded: "To Be Added",
    whatDoesThisDo: "What does this do?",
    syncInfo1: "Reads all translations from i18n.js file",
    syncInfo2: "Adds keys that are not in the DB",
    syncInfo3: "PRESERVES existing ones (does not overwrite)",
    syncInfo4: "DB becomes the Single Source of Truth",
    dbSynced: "Database is synced!",
    dbSyncedDesc: "{synced} from i18n, {added} added by users",
    dbNotSynced: "Database is not yet synced",
    dbNotSyncedDesc: "Press \"Sync\" button for initial setup",
    syncing: "Syncing...",
    syncBtn: "Sync",
  },
  documents: {
    myDocuments: "My Documents",
    myDocumentsDesc: "Company contracts and personal documents",
    management: "Document Management",
    managementDesc: "Manage firm documents",
    all: "All",
    companyDocs: "Company Documents",
    personalDocs: "Personal Documents",
    company: "Company",
    personal: "Personal",
    noDocuments: "No documents yet",
    noDocumentsDesc: "No files assigned to you",
    noDocumentsAdminDesc: "No documents uploaded yet",
    fetchError: "Failed to load files",
    uploadError: "Upload error",
    downloadError: "Failed to download file",
    downloadSuccess: "File downloading",
    previewError: "Failed to open preview",
    updateSuccess: "Updated successfully",
    updateError: "Update error",
    deleteSuccess: "Deleted successfully",
    deleteError: "Delete error",
    deleteConfirm: "Delete File",
    upload: "Upload",
    uploadFiles: "Upload Files",
    uploadDesc: "Upload or drag and drop files",
    uploadFirst: "Upload a file first",
    files: "Files",
    fileName: "File Name",
    firm: "Firm",
    category: "Category",
    assignedTo: "Assigned To",
    assignTo: "Assign To",
    assignToAll: "Assign to all employees",
    searchUsers: "Search users",
    searchPlaceholder: "Search files...",
    size: "Size",
    uploadedAt: "Uploaded at",
    preview: "Preview",
    download: "Download",
    editDocument: "Edit Document",
    invalidFileType: "Invalid file type",
    targetFirm: "Target Firm",
    allCompanies: "Global (All Firms)",
    globalDocNote: "This document applies to all firms",
    pdfLoadError: "Failed to load PDF",
    pdfCorruptOrInvalid: "PDF is corrupt or invalid",
    downloadInstead: "Download instead",
    previewNotSupported: "Preview not supported",
    noPreview: "Preview not available",
    showing: "Showing",
    of: "of",
    items: "items",
    perPage: "per page",
    deleteMessage: "Are you sure you want to delete this file? This action cannot be undone.",
    dragDrop: "Drag and drop files here",
    employee: "Employee",
    fileUploaded: "File uploaded",
    filterByFirm: "Filter by Firm",
    firmDocuments: "Firm Documents",
    firmDocumentsDesc: "Company-wide shared documents",
    or: "or",
    selectEmployee: "Select Employee",
    selectFile: "Select File",
    totalDocuments: "Total Documents",
    uploadDate: "Upload Date",
    uploadDocument: "Upload Document",
    uploadDocumentDesc: "Upload a file or drag and drop",
    uploadSuccess: "File uploaded",
    visibility: "Visibility",
    visibleToEmployee: "Visible to Employee",
    allDocuments: "All Documents",
    assignedToMe: "Assigned to Me",
    assignedDocuments: "Assigned Documents",
    companyDocuments: "Company Documents",
    dateRange: "Date Range",
    documentName: "Document Name",
    documentType: "Document Type",
    fileSize: "File Size",
    filterByType: "Filter by Type",
    noResults: "No documents found",
    private: "Private",
    public: "Public",
    uploadedBy: "Uploaded By",
    originalName: "Original",
  },
  packages: {
    title: "Packages",
    subtitle: "Invoice and distribution data",
    fetchError: "Error loading packages",
    statsError: "Error loading statistics",
    detailError: "Error loading invoice detail",
    totalInvoices: "Total Invoices",
    totalAmount: "Total Amount",
    totalEmployees: "Employee Count",
    totalRegions: "Region Count",
    totalQuantity: "Total Quantity",
    overview: "Overview",
    invoices: "Invoices",
    employees: "Employees",
    regions: "Regions",
    weeklyTrend: "Weekly Trend",
    regionDistribution: "Region Distribution",
    topEmployees: "Top Earning Employees",
    topEmployeesByPackage: "Top Employees by Package Count",
    invoiceList: "Invoice List",
    invoiceNumber: "Invoice No",
    invoiceDate: "Date",
    weekNumber: "Week",
    company: "Company",
    location: "Location",
    employeeStats: "Employee Statistics",
    employeeName: "Employee",
    routeDays: "Routes/Days Worked",
    workDays: "Work Days",
    dailyAverage: "Daily Average",
    difference: "Diff (165)",
    bonusCalculation: "Bonus Calculation",
    unitPrice: "Unit Price",
    calculation: "Calculation",
    dayShort: "days",
    clickToCopy: "Click to copy",
    copiedToClipboard: "copied",
    totalEarnings: "Total Earnings",
    regionStats: "Region Statistics",
    region: "Region",
    employeeCount: "Employee Count",
    invoiceDetail: "Invoice Detail",
    year: "Year",
    week: "Week",
    date: "Date",
    quantity: "Quantity",
    total: "Total",
    searchEmployee: "Search employee...",
    searchInvoice: "Search invoice...",
    noEmployeeFound: "No employee found matching",
    employeesShown: "employees shown",
    allCompanies: "All Companies",
    allLocations: "All Locations",
    noInvoiceFound: "No invoice found matching filters",
    invoicesShown: "invoices shown",
    deleteConfirmTitle: "Delete Invoice",
    deleteConfirmMessage: "Are you sure you want to delete this invoice and all related data (employees, regions)? This action cannot be undone.",
    deleteSuccess: "Invoice deleted successfully",
    deleteError: "Error deleting invoice",
    allRegions: "All Regions",
    allDates: "All Dates",
    unitPrice: "Unit Price",
    fixedCharge: "Fixed",
    filteredQuantity: "Filtered Quantity",
    filteredTotal: "Filtered Total",
    regionSummary: "Region Summary",
    selected: "selected",
    deleteSelected: "Delete Selected",
    bulkDeleteTitle: "Bulk Delete Invoices",
    bulkDeleteConfirmMessage: "Are you sure you want to delete these invoices and all related data (employees, regions)?",
    bulkDeleteWarning: "This action cannot be undone!",
    selectedInvoices: "Invoices to Delete",
    deleteAll: "Delete All",
    invoicesDeleted: "invoices deleted successfully",
    invoicesDeleteError: "invoices failed to delete",
    allWeeks: "All Weeks",
    selectWeeks: "Select Weeks",
    selectMonth: "Select Month",
    monthsSelected: "months selected",
    amount: "Amount",
    packageCount: "Package",
    createdAt: "Created Date",
    amountPerPackage: "Average Amount per Package",
    weeklyYearComparison: "Weekly Comparison",
    showingInvoices: "Showing",
    perPage: "Per page",
    page: "Page",
    yearlyComparison: "Yearly Comparison",
    yearlyQuantity: "Yearly Package Counts",
    driverLocationMatrix: "Driver-Location Performance Matrix",
    driverLocationMatrixDesc: "See how each driver performs at different locations",
    driver: "Driver",
    locationTotal: "Location Total",
    showingTopDrivers: "Showing top",
    drivers: "drivers",
    matrixError: "Error loading performance matrix",
    last7Days: "Last 7 Days",
    last4Weeks: "Last 4 Weeks",
    last3Months: "Last 3 Months",
    allTime: "All Time",
    seasonalTrends: "Seasonal Trend Analysis",
    seasonalInsights: "Seasonal Insights",
    monthly: "Monthly",
    quarterly: "Quarterly",
    yearOverYearGrowth: "Year-over-Year Growth",
    busiestByAmount: "Busiest (Amount)",
    busiestByPackage: "Busiest (Packages)",
    monthlyPattern: "Monthly Pattern",
    avgQuantity: "Avg. Packages",
    seasonalError: "Error loading seasonal trends",
    last6MonthsVs: "Last 6 Months vs Previous",
    last12MonthsVs: "Last 12 Months vs Previous",
    periodGrowth: "Period Comparison",
    totalAmountLabel: "Total Amount",
    totalPackageLabel: "Total Packages",
    amountPerPackageLabel: "Amount per Package",
    changePercent: "Change (%)",
    weekLabel: "Week",
    dateRange: "Date Range",
    dateRangeFilter: "Filter by Date Range",
    startDate: "Start",
    endDate: "End",
    clearSelection: "Clear",
    weeksSelected: "weeks selected",
    last3Years: "Last 3 Years",
    last4Years: "Last 4 Years",
  },
  lockedDates: {
    title: "Locked Dates",
    description: "Manage dates when employees cannot request leave",
    lockDate: "Lock Date",
    howItWorks: "How Locked Dates Work?",
    infoLine1: "Employees cannot create leave requests on locked dates",
    infoLine2: "\"Yearly Repeat\" option automatically locks the same dates every year",
    infoLine3: "You can lock dates for all firms or specific firms",
    activeLockedDates: "Active Locked Dates",
    recordsFound: "records found",
    dates: "Dates",
    reason: "Reason",
    firms: "Firms",
    repeat: "Repeat",
    createdBy: "Created By",
    noLockedDates: "No locked dates found",
    more: "more",
    allFirms: "All Firms",
    everyYear: "Every Year",
    oneTime: "One Time",
    addNewTitle: "Add New Locked Dates",
    addNewDescription: "Employees will not be able to request leave on selected dates",
    selectDates: "Select Dates",
    datesSelected: "dates selected",
    allFirmsApplies: "Will apply to all firms",
    firmsSelected: "firms selected",
    reasonPlaceholder: "E.g.: Annual inventory count, Company meeting...",
    repeatYearly: "Repeat Yearly",
    repeatYearlyDesc: "These dates will be automatically locked every year",
    lockDates: "Lock Dates",
    deleteTitle: "Delete Locked Dates",
    deleteConfirm: "This action cannot be undone. Are you sure you want to remove the date lock?",
    datesCreated: "Locked dates created",
    datesDeleted: "Locked dates deleted",
    calendarView: "Calendar",
    listView: "List",
    calendarTitle: "Locked Dates Calendar",
    lockedDay: "Locked Day",
    today: "Today",
    lockedRecords: "locked records",
  },
  forgotPassword: {
    title: "Forgot Your Password?",
    subtitle: "We will send a verification code to your email address",
    description: "Enter your email and we'll send you a verification code.",
    enterEmail: "Enter your email address",
    invalidEmail: "Enter a valid email address",
    emailPlaceholder: "example@company.com",
    emailHint: "Enter your registered email address. The verification code will be sent to this address.",
    sendCode: "Send Verification Code",
    verifyCode: "Verify Code",
    codeSentEmail: "Verification code sent to your email",
    enterCode: "Enter Verification Code",
    codeExpiry: "Code will expire in 10 minutes",
    verify: "Verify",
    resendCode: "Resend Code",
    codeResent: "New code sent",
    codeSent: "Verification code sent",
    codeVerified: "Code verified",
    invalidCode: "Invalid code",
    enterValidCode: "Please enter 6-digit code",
    newPassword: "New Password",
    confirmPassword: "Confirm Password",
    newPasswordDesc: "Create a strong password with at least 6 characters.",
    resetPassword: "Reset Password",
    passwordTooShort: "Password must be at least 6 characters",
    successTitle: "Password Changed!",
    successMessage: "You can now login with your new password.",
    successSubtitle: "Your password has been successfully changed",
    successDesc: "Your password has been successfully changed. You can now login with your new password.",
    rememberPassword: "Remember your password?",
    step1Label: "Email",
    step2Label: "Verification",
    step3Label: "Password",
    passwordResetSuccess: "Your password has been successfully reset",
  },
  dashboard: {
    totalApprovedDays: "Total Approved Days",
    pendingRequests: "Pending Requests",
    approvedRequests: "Approved Requests",
    rejectedRequests: "Rejected Requests",
    monthlyApprovedDays: "Monthly Approved Leave Days",
    monthlyWorkStatus: "Monthly Work Status",
    approvedDays: "Approved Days",
    working: "Working",
    halfDay: "Half Day",
    sick: "Sick",
    dop: "DOP",
    onLeave: "On Leave",
    recentRequests: "Recent Requests",
    adjustment: "adjustment",
    statusDistribution: "Status Distribution",
    topLeaveTypes: "Top Leave Types",
    capacityHotspots: "Capacity Hotspots",
    firmComparison: "Firm Comparison",
    myPlanning: "My Planning",
    planningLoading: "Loading planning...",
    upcomingCount: "{{count}} upcoming",
    historyCount: "{{count}} past",
    viewList: "List",
    viewWeek: "Week",
    today: "Today",
    noAssignmentToday: "No assignment for today.",
    nextSevenDays: "Next 7 days",
    historyWith: "History ({{count}})",
    week: "Week",
    thisWeek: "Today",
    prevWeek: "Previous week",
    nextWeek: "Next week",
    weekDaysToggle: "5 or 7 days",
    sevenDaysShort: "7 days",
    fiveDaysShort: "5 days",
    daysShort: { 0: "Sun", 1: "Mon", 2: "Tue", 3: "Wed", 4: "Thu", 5: "Fri", 6: "Sat" },
    monthsShort: { 0: "Jan", 1: "Feb", 2: "Mar", 3: "Apr", 4: "May", 5: "Jun", 6: "Jul", 7: "Aug", 8: "Sep", 9: "Oct", 10: "Nov", 11: "Dec" },
    quickActions: "Quick Actions",
    requests: "requests",
    globalView: "Global View",
    allFirms: "All Firms",
    activeEmployees: "Active Employees",
    pendingRegistrations: "Pending Registrations",
    todayWorking: "Working Today",
    clickToSeeDetails: "Click to see details",
    todayStatus: "Your Status Today",
    noStatusYet: "Not set yet",
    createLeaveHint: "Create your leave request quickly",
    workStatusHint: "View your daily work status",
    myRecentRequests: "My Recent Requests",
    lastFiveRequests: "Your last 5 requests",
    viewAll: "View All",
    vehicleWarnings: "Vehicle Warnings",
    critical: "Critical",
    warning: "Warning",
    viewAllVehicles: "View All",
    andMoreVehicles: "and {{count}} more vehicles...",
    andMorePeople: "and {{count}} more people... View All",
    allDocsUpToDate: "All documents are up to date",
    noExpiringDocs: "No documents expiring within 90 days.",
    expiryAlertSent: "Document expiry notification sent to {count} people.",
    noExpiryAlertNeeded: "No one found to send notification.",
    sendAlert: "Send Alert",
    sendAlertError: "Failed to send alert",
    checking: "Checking...",
    checkExpiryTooltip: "Check for expiring documents and trigger alerts",
    todos: "To-Do",
    noTodos: "No open tasks.",
    markDone: "Mark done",
    lastCheck: "Last check",
    expired: "Expired",
    criticalDays: "Critical (30 days)",
    warningDays: "Warning (90 days)",
    totalPeople: "Total: {count} people",
    insuranceExpired: "Insurance expired {days} days ago!",
    insuranceExpiring: "Insurance expires in {days} days",
    inspectionExpired: "Inspection expired {days} days ago!",
    inspectionExpiring: "Inspection expires in {days} days",
    maintenanceOverdue: "Maintenance overdue by {days} days!",
    maintenanceUpcoming: "Maintenance due in {days} days",
  },
  months: {
    jan: "Jan",
    feb: "Feb",
    mar: "Mar",
    apr: "Apr",
    may: "May",
    jun: "Jun",
    jul: "Jul",
    aug: "Aug",
    sep: "Sep",
    oct: "Oct",
    nov: "Nov",
    dec: "Dec",
  },
  auth: {
    email: "Email",
    password: "Password",
    passwordConfirm: "Confirm Password",
    fullName: "Full Name",
    gsm: "Phone",
    language: "Language",
    loginTitle: "Sign in to your account",
    registerTitle: "Create a new account",
    registerRightTitle: "Join Our Community",
    registerRightDesc: "Create your account and start managing leave requests efficiently.",
    registerSuccessTitle: "Registration Successful!",
    registerSuccessMsg: "Your account has been created. You can log in after admin approval.",
    pendingApproval: "Your account is pending approval. Please wait for admin confirmation.",
    forgotPassword: "Forgot Password",
    noAccount: "Don't have an account?",
    hasAccount: "Already have an account?",
    welcomeBack: "Sign in to your account",
    loginSuccess: "Login successful",
    rememberMe: "Remember me",
    biometricLogin: "Biometric Login",
    biometricNotRegistered: "No biometric credentials found on this device",
    orBiometric: "or",
    registerSuccess: "Registration successful. Your account is pending approval.",
    invalidCredentials: "Invalid email or password",
    accountPending: "Your account is pending approval. Please wait for admin confirmation.",
    accountRejected: "Your account has been rejected.",
    accountCreated: "Your account has been created successfully.",
    firmAssignmentPending: "After your firm assignment is completed, your account approval process will be finalized and you will be notified.",
    loginAfterApproval: "Login will not be possible until the approval process is completed.",
    step1: "Personal Info",
    step2: "Security",
    invalidResetLink: "Invalid password reset link",
    invalidLink: "Invalid Link",
    setNewPassword: "Set New Password",
    setNewPasswordDescription: "Set a new password for your account",
    newPassword: "New Password",
    confirmNewPassword: "Confirm New Password",
    passwordMinLength: "Password must be at least 6 characters",
    passwordsDoNotMatch: "Passwords do not match",
    passwordResetSuccess: "Password changed successfully",
    passwordChanged: "Password Changed",
    passwordResetSuccessMessage: "Your password has been changed successfully. You can now login with your new password.",
    setPassword: "Set Password",
    backToLogin: "Back to login",
    twoFA: "Two-Factor Authentication (2FA)",
    twoFAVerification: "2FA Verification",
    twoFASetup: "2FA Setup",
    twoFAEnabled: "2FA Active",
    twoFADisabled: "2FA Inactive",
    twoFAActive: "Active",
    twoFAInactive: "Inactive",
    twoFAProtected: "Your account is protected with two-factor authentication",
    twoFAEncourage: "Enable 2FA to make your account more secure",
    twoFASupportedApps: "Google Authenticator, Microsoft Authenticator, Authy and other TOTP apps are supported",
    twoFAEnable: "Enable 2FA",
    twoFADisable: "Disable 2FA",
    twoFABackupCodes: "Backup Codes",
    twoFAYourBackupCodes: "Your Backup Codes",
    twoFAScanQR: "Scan the QR code below with your authenticator app:",
    twoFACantScanQR: "Can't scan the QR code?",
    twoFAScannedNext: "I've scanned it, continue",
    twoFAEnterCode: "Enter the 6-digit code from your authenticator app:",
    twoFAVerifyAndEnable: "Verify and Enable",
    twoFASaveBackupCodes: "Save these backup codes in a safe place. You can use them to sign in if you lose access to your authenticator app.",
    twoFACopyCodes: "Copy Codes",
    twoFAComplete: "Done",
    twoFADisableConfirm: "Enter your password to disable 2FA:",
    twoFAYourPassword: "Your password",
    twoFACancel: "Cancel",
    twoFARemainingCodes: "Remaining: {count} codes",
    twoFACopy: "Copy",
    twoFARegenerate: "Regenerate",
    twoFACopied: "Copied!",
    twoFALoginPrompt: "enter the 6-digit code from your authenticator app",
    twoFALoginBackupPrompt: "enter your backup code",
    twoFAUseBackupCode: "Use backup code",
    twoFAUseAuthCode: "Use authenticator code",
    twoFABackToLogin: "Back to login",
    twoFASecureConnection: "Secure connection established",
    registrationPending: "Registration Pending",
    waitingApproval: "Waiting for Approval",
  },
  leave: {
    sick: "Sick Leave",
    personal: "Personal Leave",
    paternity: "Paternity Leave",
    kleinVerlet: "Klein-Verlet",
    unpaid: "Unpaid Leave",
    total: "Total",
    used: "Used",
    remaining: "Remaining",
    entitled: "Entitled",
    request: "Leave Request",
    requests: "Leave Requests",
    newRequest: "Create New Request",
    balances: "Leave Balances",
    days: "days",
    day: "day",
    selectYear: "Select Year",
    noBalances: "No leave balances found",
    adjustBalance: "Adjust Balance",
    adjustmentReason: "Adjustment Reason",
    addDays: "Add Days",
    removeDays: "Remove Days",
    adjustmentHistory: "Adjustment History",
    requiresDocument: "Requires Document",
    leaveTypes: "Leave Types",
    viewBalances: "View Balances",
    previousYears: "Previous Years",
    createRequest: "Create Leave Request",
    selectType: "Select Leave Type",
    type: "Leave Type",
    selectedType: "Selected Leave Type",
    selectDates: "Select Dates",
    reviewSubmit: "Review & Submit",
    startDate: "Start Date",
    endDate: "End Date",
    description: "Description",
    descriptionPlaceholder: "Add a note about your leave request...",
    documentUpload: "Upload Document",
    documentOptional: "Document upload is optional",
    documentRecommended: "Document is recommended for this leave type",
    confirmRequest: "I confirm this request is correct",
    submitRequest: "Submit Request",
    requestCreated: "Leave request created successfully",
    requestUpdated: "Leave request updated",
    requestCancelled: "Leave request cancelled",
    requestDeleted: "Leave request deleted",
    deleteRequest: "Delete Request",
    deleteRequestConfirm: "Are you sure you want to delete this leave request? This action cannot be undone.",
    noRequests: "You have no leave requests yet",
    cancelRequest: "Cancel Request",
    editRequest: "Edit Request",
    viewDetails: "View Details",
    insufficientBalance: "Insufficient leave balance",
    datesOverlap: "Selected dates overlap with an existing leave request",
    blockedDays: "Blocked Days",
    blockedDaysWarning: "Selected dates include fully booked days",
    dayFullyBooked: "This day is full (5+ approved requests)",
    calendarView: "Calendar View",
    selectedRange: "Selected Dates",
    pending: "Pending",
    approved: "Approved",
    rejected: "Rejected",
    cancelled: "Cancelled",
    step1: "Step 1",
    step2: "Step 2",
    step3: "Step 3",
    step1Title: "Step 1: Select leave type",
    step2Title: "Step 2: Select dates",
    selectDaysHint: "Select at least one day from the calendar",
    locked: "Locked",
    summary: "Summary",
    myRequests: "My Leave Requests",
    archived: "Archived",
    selectTypeFirst: "Please select a leave type first",
    selectDays: "Please select at least one day",
    noDaysSelected: "Select days from the calendar",
    totalDays: "Total Days",
    selectedDays: "Selected Days",
    selectedDates: "Selected Dates",
    selected: "Selected",
    weekend: "Weekend",
    calendarTip: "Click on the calendar to select the days you want to take leave. Click again to deselect.",
    requestedAt: "Request Date",
    more: "more",
    daysAvailable: "days left",
    maxDays: "Max",
    maxDaysReached: "You can select maximum {days} days for this leave type",
    selectLeaveTypeFirst: "Select leave type first",
    selectLeaveTypeFirstDesc: "You need to select a leave type above before selecting dates",
    annual: "Annual Leave",
    calendarTipShort: "Click on days to select/deselect",
    noRemainingDays: "No remaining days",
    remainingDays: "Remaining Days",
    requestSubmitted: "Leave request submitted",
    selectLeaveType: "Select leave type",
  },
  leaveCalendar: {
    deleteLeave: "Delete Leave",
    deleteConfirmTitle: "Delete Leave",
    deleteConfirmMessage: "Are you sure you want to delete this leave?",
    deleteBalanceNote: "For approved leaves, used days will be restored to the balance.",
    confirmDelete: "Yes, Delete",
    deleteSuccess: "Leave deleted successfully",
    deleteError: "Error deleting leave",
    balanceRestored: "{days} days restored to balance",
    cannotDeletePast: "Past leaves cannot be deleted",
    removeThisDay: "Remove Only This Day",
    removeDayConfirmTitle: "Remove This Day",
    removeDayConfirmMessage: "Are you sure you want to remove this day from the leave?",
    confirmRemoveDay: "Yes, Remove Day",
    deleteEntireLeave: "Delete Entire Leave",
    dayRemovedSuccess: "{date} removed from leave",
    removeDayError: "Error removing day from leave",
  },
  admin: {
    userManagement: "User Management",
    createUser: "Add User",
    createUserDesc: "Manually add a new user to the system",
    firmManagement: "Firm Management",
    pendingApprovals: "Pending Approvals",
    auditLogs: "Audit Logs",
    statistics: "Statistics",
    totalUsers: "Total Users",
    totalFirms: "Total Firms",
    pendingUsers: "Pending Users",
    activeUsers: "Active Users",
    approveUser: "Approve User",
    rejectUser: "Reject User",
    rejectReason: "Rejection Reason",
    selectFirm: "Select Firm",
    createFirm: "Create Firm",
    firmName: "Firm Name",
    firmLogo: "Firm Logo",
    selectRole: "Select Role",
    roleEmployee: "Employee",
    roleFirmAdmin: "Firm Administrator",
    confirmApprove: "Are you sure you want to approve this user?",
    confirmReject: "Are you sure you want to reject this user?",
    approveConfirmation: "This action cannot be undone.",
    rejectConfirmation: "This action cannot be undone.",
    firmRequired: "Firm selection is required",
    reasonRequired: "Rejection reason is required (minimum 5 characters)",
    userApproved: "User approved successfully",
    userRejected: "User rejected",
    pendingTab: "Pending",
    activeTab: "Active",
    rejectedTab: "Rejected",
    createdAt: "Created At",
    leaveRequestManagement: "Leave Management",
    leaveManagement: "Leave Management",
    listView: "List",
    calendarView: "Calendar",
    approveRequest: "Approve Request",
    rejectRequest: "Reject Request",
    cancelRequest: "Cancel Request",
    archiveRequest: "Archive",
    editRequest: "Edit",
    confirmApproveLeave: "Are you sure you want to approve this leave request?",
    confirmRejectLeave: "Are you sure you want to reject this leave request?",
    confirmCancelLeave: "Are you sure you want to cancel this approved leave request?",
    confirmArchiveLeave: "Are you sure you want to archive this leave request?",
    leaveApproved: "Leave request approved",
    leaveApprovedWithWarnings: "Leave approved with warnings (Super Admin override)",
    warn: {
      insufficientBalance: "Insufficient balance: {{requested}} days requested, {{available}} days available",
      daysFullyBooked: "Days are fully booked (5+ approved): {{dates}}",
      lockedDates: "Locked dates: {{dates}}",
      dateOverlap: "Dates overlap with another approved leave request",
      noBalance: "Leave balance not found",
    },
    leaveRejected: "Leave request rejected",
    leaveCancelled: "Leave request cancelled",
    leaveArchived: "Leave request archived",
    leaveUpdated: "Leave request updated",
    samePeriodsOnLeave: "Staff on leave during these dates:",
    overlappingDates: "Overlapping dates",
    requester: "Requester",
    leaveType: "Leave Type",
    dateRange: "Date Range",
    daysCount: "Days",
    requestDate: "Request Date",
    adminNote: "Admin Note",
    adminNotePlaceholder: "Admin note (optional)...",
    enterReason: "Enter reason",
    notifyUser: "Notify User",
    notifyBySms: "By SMS",
    notifyByEmail: "By Email",
    notifyByWhatsapp: "By WhatsApp",
    balanceInfo: "Balance Info",
    capacityWarning: "Capacity Warning",
    archivedTab: "Archived",
    allRequests: "All Requests",
    approveLeaveConfirmation: "You are about to approve this user's leave request.",
    rejectReasonRequired: "Rejection reason is required",
    searchUsers: "Search by name, email, or phone...",
    allFirms: "All Firms",
    firm: "Firm",
    noUsersFound: "No users found",
    viewDetails: "Details",
    fullName: "Full Name",
    email: "Email",
    phone: "Phone",
    role: "Role",
    status: "Status",
    suspended: "Suspended",
    suspendUser: "Suspend User",
    activateUser: "Activate",
    activate: "Activate",
    suspend: "Suspend",
    activateConfirm: "This user will be activated and can login to the system.",
    suspendConfirm: "This user will be suspended and cannot login to the system.",
    userActivated: "User activated",
    userSuspended: "User suspended",
    reapprove: "Re-approve",
    employee: "Employee",
    firmAdmin: "Firm Admin",
    confirmApproval: "Confirm Approval",
    approvalSummary: "Approval Summary",
    rejectionWarning: "Warning",
    rejectionMessage: "This user will be rejected and cannot login to the system.",
    reason: "Reason",
    rejectReasonPlaceholder: "Explain the rejection reason...",
    userDeleted: "User deleted",
    deleteUserWarning: "This action cannot be undone. All user data will be deleted.",
    impersonate: "Login as User",
    sendPasswordReset: "Send Password Reset",
    sendPasswordResetTitle: "Send Password Reset Email",
    passwordResetSent: "Password reset link sent to {email}",
    sendEmail: "Send Email",
    setPassword: "Set Password",
    setPasswordTitle: "Set Password",
    newPassword: "New Password",
    generatePassword: "Generate Random",
    setPasswordConfirm: "Save Password",
    changeFirm: "Change Firm",
    newFirm: "New Firm",
    transfer: "Transfer",
    transferSuccess: "User transferred successfully",
    selectDifferentFirm: "Please select a different firm",
    firmTransferWarning: "This action does not affect the user's leave balances.",
    changeRole: "Change Role",
    pagePermissions: "Page Permissions",
    allowedFirms: "Allowed Firms",
    allowedFirmsDesc: "Leave empty to deny all firm access",
    pageAccess: "Page Access",
    pageAccessDesc: "Leave empty to allow all pages",
    additionalPermissions: "Additional Permissions",
    canDelete: "Delete Permission",
    canDeleteDesc: "Can delete records",
    canViewFinancial: "View Financial Records",
    canViewFinancialDesc: "Can view financial entries and advance sections",
    canSendNotifications: "Send Notifications",
    canSendNotificationsDesc: "Can send notifications to users",
    newRole: "New Role",
    changeRoleBtn: "Change Role",
    roleChanged: "User role changed",
    selectDifferentRole: "Please select a different role",
    firmAdminWarning: "Firm Admin can manage users and leave requests in their firm.",
    export: "Export",
    import: "Import",
    importUsers: "Import Users",
    exportSuccess: "Users exported",
    importSuccess: "Users imported",
    importAndUpdate: "Import and Update",
    importPreview: "Preview",
    importResults: "Results",
    created: "Created",
    updated: "Updated",
    skipped: "Skipped",
    errors: "Errors",
    impersonateAs: "viewing as",
    returnToAdmin: "return to account",
    confirmDeleteLeaveRequest: "Are you sure you want to permanently delete this leave request?",
    confirmDeleteUser: "Are you sure you want to delete this user?",
    deleteLeaveRequest: "Delete Leave Request",
    deleteLeaveRequestSuccess: "Leave request deleted",
    deleteUser: "Delete User",
    deleteUserDesc: "This action cannot be undone. The user and all related data will be removed.",
    deleteUserSuccess: "User deleted",
    enterPanel: "Enter Panel",
    fullAdminWarning: "Full Admin can manage users and leave requests across assigned firms.",
    leaveRequestDeleted: "Leave request permanently deleted",
    hardDelete: "Hard Delete",
    hardDeleteTitle: "Hard Delete (Super Admin)",
    hardDeleteWarning: "This bypasses ALL validations and permanently deletes the leave record. Balance will NOT be restored. Past records can also be deleted.",
    hardDeleteConfirmPrompt: "Type HARDSIL in uppercase to confirm:",
    hardDeleteConfirmWord: "HARDSIL",
    hardDeleteConfirmButton: "Yes, Force Delete",
    hardDeleteSuccess: "Leave request hard deleted",
    hardDeleteTooltip: "Hard Delete: bypass all rules (Super Admin only)",
    loginAs: "Log in as",
    permissionsSaved: "Permissions saved",
    resetPassword: "Reset Password",
    sendResetPassword: "Send Password Reset",
    suspendUserDesc: "Suspended users cannot log in to the system.",
    unsuspendUser: "Activate User",
    updatePermissions: "Update Permissions",
    userDetails: "User Details",
    userUnsuspended: "User activated",
    deleteWarning: "This action cannot be undone!",
    enableLandingPage: "Enable Landing Page",
    frontendSettings: "Frontend Settings",
    frontendSettingsDescription: "Customize application frontend appearance",
    landingDisabledWarning: "Landing page disabled",
    landingPageImage: "Landing Page Image",
    landingPageNote: "Landing page note",
    landingPageToggle: "Landing Page",
    landingPageToggleDesc: "Show/hide landing page",
    loginPageImage: "Login Page Image",
    pageImages: "Page Images",
    pageImagesDesc: "Manage login and registration page images",
    registerPageImage: "Register Page Image",
    settingsSaved: "Settings saved",
    siteName: "Site Name",
    siteNameDesc: "Change the displayed application name",
    siteNameHelp: "This name appears in browser tab and login page",
    siteNameLabel: "Site Name",
    superAdminRequired: "Super Admin permission required",
    confirmRejection: "Are you sure you want to reject?",
  },
  login: {
    heroTitle: "Manage your team's leave efficiently",
    heroDescription: "Streamline leave requests, approvals, and tracking all in one place.",
  },
  landing: {
    heroTitle: "Next Generation Leave Management",
    heroSubtitle: "Easily manage, approve, and track your employees' leave requests in a digital environment.",
    getStarted: "Get Started",
    learnMore: "Learn More",
    features: "Features",
    feature1Title: "Easy Leave Tracking",
    feature1Desc: "Track annual, sick, and personal leaves from a single dashboard.",
    feature2Title: "Fast Approval Process",
    feature2Desc: "Managers can instantly approve or reject leave requests.",
    feature3Title: "Multi-Tenant Support",
    feature3Desc: "Manage multiple companies from a single platform.",
  },
  notifications: {
    title: "Notifications",
    subtitle: "Manage SMS, Email and WhatsApp notification settings",
    settings: "Settings",
    outbox: "Outbox",
    enabled: "Enabled",
    disabled: "Disabled",
    channel: "Channel",
    event: "Event",
    recipient: "Recipient",
    status: "Status",
    attempts: "Attempts",
    message: "Message",
    details: "Details",
    lastError: "Last Error",
    settingsSaved: "Notification settings saved",
    testSend: "Test Send",
    testDescription: "Send a test notification for this channel",
    testSent: "Test notification sent",
    retryQueued: "Queued for retry",
    send: "Send",
    providerUrl: "Provider URL",
    apiKey: "API Key",
    sender: "Sender",
    timeout: "Timeout (ms)",
    smtpHost: "SMTP Host",
    smtpPort: "SMTP Port",
    smtpUser: "SMTP User",
    smtpPass: "SMTP Password",
    fromAddress: "From Address",
    emailAddress: "Email Address",
    phoneNumber: "Phone Number",
    emailProvider: "Email Provider",
    mandrillApiKey: "Mandrill API Key",
    fromName: "From Name",
    replyTo: "Reply To",
    smsApiNote: "API called with gsm, mesaj, mesajturu parameters",
    defaultMesajTuru: "Default Message Type",
    retry: "Retry",
    retryWithReset: "Retry with Reset",
    confirmDelete: "Are you sure you want to delete this notification?",
    deleted: "Notification deleted",
    selectToDelete: "Select notifications to delete",
  },
  validation: {
    required: "This field is required",
    invalidEmail: "Enter a valid email address",
    passwordMin: "Password must be at least 6 characters",
    passwordMatch: "Passwords do not match",
    phoneFormat: "Enter a valid phone number",
  },
  profile: {
    changePassword: "Change Password",
    confirmNewPassword: "Confirm New Password",
    currentPassword: "Current Password",
    incorrectPassword: "Current password is incorrect",
    languageSettings: "Language Settings",
    lastLogin: "Last Login",
    memberSince: "Member Since",
    newPassword: "New Password",
    passwordChanged: "Password changed",
    passwordMismatch: "Passwords do not match",
    accountActive: "Your account is active",
    accountInactive: "Your account is inactive",
    accountInfo: "Account Information",
    accountRejected: "Your account has been rejected",
    accountStatus: "Account Status",
    company: "Company",
    darkMode: "Dark Mode",
    email: "Email",
    fullName: "Full Name",
    language: "Language",
    phone: "Phone",
    phoneNumber: "Phone Number",
    role: "Role",
    settings: "Settings",
    theme: "Theme",
    waitingApproval: "Waiting for approval",
  },
  calendar: {
    title: "Leave Calendar",
    description: "Calendar view of approved leaves",
    monthly: "Monthly",
    weekly: "Weekly",
    today: "Today",
    employeesOnLeave: "Employees on Leave",
    totalLeaveDays: "Total Leave Days",
    approvedLeaves: "Approved Leaves",
    monday: "Mon",
    tuesday: "Tue",
    wednesday: "Wed",
    thursday: "Thu",
    friday: "Fri",
    saturday: "Sat",
    sunday: "Sun",
  },
  leaveTypes: {
    title: "Leave Types",
    description: "Manage leave types in the system",
    add: "New Leave Type",
    total: "Total",
    active: "Active",
    inactive: "Inactive",
    code: "Code",
    name: "Name",
    defaultDays: "Default Days",
    defaultLabel: "Default",
    requiresDocument: "Requires Document",
    status: "Status",
    isActive: "Active",
    createTitle: "Create New Leave Type",
    createDescription: "Define a new leave type for the system",
    editTitle: "Edit Leave Type",
    edit: "Edit",
    deleteTitle: "Delete Leave Type",
    created: "Leave type created",
    updated: "Leave type updated",
    deleted: "Leave type deleted",
    activated: "Leave type activated",
    deactivated: "Leave type deactivated",
    codeAndNameRequired: "Code and name are required",
    noData: "No leave types defined yet",
    viewUsers: "Users",
    usersWithType: "Users with this Leave Type",
    totalBalances: "Total Balance",
    totalRequests: "Total Requests",
    noUsersWithType: "No one is using this leave type",
    canSafelyDelete: "You can safely delete this leave type",
    balanceRemoved: "Balance removed",
    removeBalance: "Remove Balance",
    cannotRemoveWithRequests: "Cannot remove balance for users with leave requests",
    warningRequestsExist: "Leave requests exist for this type. Remove balances before deleting.",
    adminOnly: "Admin Only",
    adminOnlyDesc: "Users cannot see this type in their leave requests",
    yes: "Yes",
    no: "No",
    days: "days",
    orphanBalance: "Orphan Balance",
    duplicateCheck: "Duplicate Check",
    color: "Color",
    onlyUppercaseAndUnderscore: "Only uppercase letters and underscore",
    daysCountChanged: "Days count changed",
  },
  customers: {
    title: "Customer Management",
    description: "Manage route form fields per customer",
    newCustomer: "Create New Customer",
    editCustomer: "Edit {{name}}",
    name: "Customer Name",
    nameRequired: "Customer name is required",
    slug: "Slug (Unique Code)",
    calculationType: "Calculation Type",
    fields: "Fields",
    created: "Customer created",
    updated: "Customer updated",
    deleted: "Customer deleted",
    save: "Save",
    cancel: "Cancel",
    delete: "Delete",
    edit: "Edit",
    addButton: "New Customer",
    system: "System",
    custom: "Custom",
    noCustomers: "No customers defined yet",
    deleteTitle: "Delete Customer",
    deleteMessage: "Are you sure you want to delete {{name}}?",
    atLeastOneField: "You must select at least one field",
    operationFailed: "Operation failed",
    cannotDelete: "Could not delete",
    deleteFailed: "Delete operation failed",
    errorOccurred: "An error occurred",
    calculationMethod: "Calculation Method",
    formFields: "Form Fields",
    fieldsSelected: "fields selected",
    defaultValue: "Default",
    preview: "Preview",
    calculation: "Calculation",
    update: "Update",
    create: "Create",
    example: "Ex",
    defaultsCreated: "Default customers created",
    namePlaceholder: "Customer name",
    slugPlaceholder: "customer_slug",
    categoryBase: "Basic Fields",
    categoryIdentity: "Identity / Number",
    categoryPersonnel: "Personnel",
    categoryDistance: "Distance",
    categoryPricing: "Pricing",
    categoryTime: "Time",
    color: "Color",
  },
  vehicles: {
    title: "My Vehicles",
    detail: "Vehicle Detail",
    generalInfo: "General Information",
    technicalInfo: "Technical Information",
    ownershipSale: "Ownership & Sale",
    notes: "Notes",
    noNotes: "No notes",
    documents: "Documents",
    photos: "Photos",
    maintenanceInsurance: "Maintenance & Insurance",
    insurance: "Insurance",
    inspection: "Inspection",
    maintenance: "Maintenance",
    activeWarnings: "Active Warnings",
    edit: "Edit",
    save: "Save",
    cancelEdit: "Cancel",
    uploadDoc: "Upload",
    uploadPhoto: "Upload Photo",
    dragDropDocs: "Drag and drop files here",
    dragDropPhotos: "Drag and drop photos here",
    orUseButton: "or use the upload button",
    subtitle: "Manage company vehicles",
    sendReminder: "Send Reminder",
    excelUpload: "Upload Excel",
    newVehicle: "New Vehicle",
    searchLabel: "Search",
    searchPlaceholder: "Plate, brand, model, firm...",
    fuelTypeFilter: "Fuel Type",
    statusFilter: "Status",
    all: "All",
    ok: "OK",
    warningStatus: "Warning",
    criticalStatus: "Critical",
    totalVehicles: "Total Vehicles",
    firmCount: "Firm Count",
    hasWarnings: "Has Warnings",
    hasCritical: "Critical",
    brandDistribution: "Brand Distribution",
    fuelDistribution: "Fuel Type Distribution",
    unknownBrand: "Unknown",
    notSpecified: "Not Specified",
    noDataFound: "No data found",
    vehicleList: "Vehicle List",
    vehicleCount: "vehicles",
    totalLabel: "total",
    hideChart: "Hide Chart",
    showBrandChart: "Brand Chart",
    selectedCount: "vehicles selected",
    deleteSelected: "Delete Selected",
    noVehicles: "No vehicles found",
    addFirst: "Add First Vehicle",
    editVehicle: "Edit Vehicle",
    addVehicle: "Add New Vehicle",
    plateRequired: "License plate is required",
    firmRequired: "Firm selection is required",
    vehicleUpdated: "Vehicle updated",
    vehicleAdded: "Vehicle added",
    vehicleDeleted: "Vehicle deleted",
    deleteError: "Delete error",
    importError: "Import error",
    notificationFailed: "Notification could not be sent",
    bulkDeleteError: "Bulk delete error",
    errorOccurred: "An error occurred",
    selectFirm: "Select firm",
    platePlaceholder: "Ex: 1-ABC-123",
    brandPlaceholder: "Ex: Ford",
    modelPlaceholder: "Ex: Transit",
    yearPlaceholder: "Ex: 2023",
    selectColor: "Select color",
    vehicleDetailsSection: "Vehicle Details",
    chassisPlaceholder: "Chassis number",
    loadPlaceholder: "Ex: 1162 KG",
    fuelSelectLabel: "Fuel type",
    permitPlaceholder: "Permit number",
    ownershipPlaceholder: "Ownership type",
    purchasePlaceholder: "Purchase location",
    insuranceCompanyLabel: "Insurance company",
    maintenanceTracking: "Maintenance & Insurance Tracking",
    insuranceExpiryDate: "Insurance Expiry Date",
    inspectionExpiryDate: "Inspection Expiry Date",
    lastMaintenanceDate: "Last Maintenance Date",
    nextMaintenanceDate: "Next Maintenance Date",
    lastMaintenanceKmLabel: "Last Maintenance KM",
    nextMaintenanceKmLabel: "Next Maintenance KM",
    notesLabel: "Notes",
    notesPlaceholder: "Additional info...",
    selectOption: "Select",
    maintenanceKmPlaceholder: "Ex: 50000",
    nextMaintenanceKmPlaceholder: "Ex: 60000",
    ruhsatInVehicle: "In vehicle",
    ruhsatOutVehicle: "Outside vehicle",
    tableStatus: "Status",
    tablePlate: "Plate",
    tableBrandModel: "Brand / Model",
    tableYear: "Year",
    tableFuel: "Fuel",
    tableOwnership: "Ownership",
    tableInsurance: "Insurance",
    tableInspection: "Inspection",
    tableNextMaintenance: "Next Maintenance",
    tableFirm: "Firm",
    documentsTitle: "Documents",
    vehicleDetailTitle: "Vehicle Detail",
    deleteVehicleTitle: "Delete Vehicle",
    deleteVehicleConfirm: "Are you sure you want to delete the vehicle with plate",
    bulkDeleteTitle: "Bulk Vehicle Delete",
    bulkDeleteMessage: "vehicles will be deleted. This action cannot be undone.",
    deleteCountBtn: "Delete Vehicles",
    buildYear: "Build Year",
    showSold: "Show sold",
    resetFilters: "Reset",
    vehicleLoadError: "Failed to load vehicle",
    saved: "Saved",
    saveError: "Save error",
    docUploaded: "{{count}} document(s) uploaded",
    uploadError: "Upload error",
    docDeleted: "Document deleted",
    updateError: "Update error",
    photoUploaded: "{{count}} photo(s) uploaded",
    photoDeleted: "Photo deleted",
    previewError: "Failed to load preview",
    pdfLoadError: "Failed to load PDF",
    loadingPreview: "Loading...",
    sold: "SOLD",
    ownershipType: "Lease / Ownership",
    plate: "License Plate",
    brand: "Brand",
    model: "Model",
    color: "Color",
    firm: "Firm",
    chassisNumber: "Chassis Number",
    loadCapacity: "Load Capacity",
    fuelType: "Fuel Type",
    permitNumber: "Permit Number",
    sticker: "Sticker",
    insuranceCompany: "Insurance Company",
    expiryDate: "Expiry Date",
    lastMaintenance: "Last Maintenance",
    nextMaintenance: "Next Maintenance",
    lastMaintenanceKm: "Last Maintenance KM",
    nextMaintenanceKm: "Next Maintenance KM",
    purchaseLocation: "Purchase Location",
    purchaseDate: "Purchase Date",
    saleDate: "Sale Date",
    keuring: "Inspection",
    ruhsat: "Registration Document",
    vergunning: "Vergunning",
    sigortaPolicesi: "Insurance Policy",
    muayeneRaporu: "Inspection Report",
    bakimRaporu: "Maintenance Report",
  },
  dailyStatus: {
    title: "Daily Employee Status",
    description: "Track employees' daily status",
    today: "Today",
    status: "Status",
    selectStatus: "Select Status",
    legend: "Status Legend",
    noUsers: "No users found",
    updatedBy: "Updated by",
    working: "Working",
    halfDay: "Half Day",
    sick: "Sick",
    dop: "Day Off",
    onLeave: "On Leave",
    paternity: "Paternity Leave",
    notSet: "Not Set",
    cancel: "Cancel",
    goToPage: "View All Statuses",
    clickToApplyAll: "Click to apply to all",
    setAllTo: "Set all to {status}",
    clearAllStatuses: "Clear all statuses",
    updatingAll: "Updating all users...",
    bulkUpdateTitle: "Bulk Status Change",
    bulkUpdateConfirm: "Are you sure you want to change all employees' status to \"{status}\"?",
    usersWillBeUpdated: "users will be updated",
    filteredUsers: "Search filter applied",
    applyToAll: "Apply to All",
    bulkUpdateSuccess: "{count} users status updated",
    bulkUpdateError: "{count} users could not be updated",
    allUsersAlreadyHaveStatus: "All users already have this status",
    daySummary: "Day Summary",
    showEmployees: "Show Employees",
    hideEmployees: "Hide Employees",
    quickEditMode: "Quick Marking Mode",
    quickEditActive: "selected - Click on cells to mark quickly",
    clickAgainToClear: "Click again to clear",
    clickStatusToActivate: "Select a status to start quick marking",
    tapCellToApply: "Tap cell",
    clickCellToApply: "Click on a cell to apply status • Click again to clear",
    switchTo: "Switch:",
    exitQuickEdit: "Exit",
    overwriteConfirmTitle: "Existing Status Will Be Changed",
    overwriteConfirmDesc: "This cell already has a status. Do you want to change it?",
    currentStatus: "Current Status",
    newStatus: "New Status",
    confirmOverwrite: "Yes, Change",
    allUsersHaveStatus: "All users already have a status",
    skippedExisting: "existing status skipped",
    willBeUpdated: "Will Update",
    willBeSkipped: "Will Skip",
    existingStatusesProtected: "Existing statuses will be preserved",
    externalFirm: "External Firm",
    selectExternalFirm: "Select firm...",
    willShowAs: "Will show as:",
    syncLeaves: "Sync Leaves",
    syncLeavesTitle: "Leave Synchronization",
    syncLeavesDesc: "Sync approved leaves to daily status",
    syncEmployees: "employees with",
    syncMissingDays: "missing days found",
    missingDayCount: "missing days",
    syncUser: "Sync",
    syncAll: "Sync All",
    allSynced: "All leaves synced!",
    noMissingDays: "No missing days found.",
    day: "days",
    allEmployees: "all employees",
    bulkWarning: "Status will be updated for all employees",
    cannotEditPastDates: "You don't have permission to edit past dates",
    confirmPastEdit: "Yes, Edit",
    noPastEditPermission: "No permission to edit past dates",
    pastDateConfirmMessage: "You are about to change employee status on a past date. Continue?",
    pastDateConfirmTitle: "Edit Past Date?",
    selectedEmployees: "employees selected",
    showOnlyWorking: "Only Working",
    statusUpdated: "Status updated",
    todayShort: "Today",
    weekViewLabel: "Week",
    changesSaved: "Changes saved",
    employeesUpdated: "Employees updated",
    noChanges: "No changes",
    pastDateConfirmNote: "This does not affect locked dates",
    pastDateWarning: "Editing past date",
    pendingChanges: "There are pending changes",
  },
  leaveRequestsAdmin: {
    addForUser: "Add Leave for User",
    addForUserDesc: "Create a leave request on behalf of a user",
    autoApprove: "Auto Approve",
    autoApproveDesc: "Leave request is immediately approved and deducted from balance",
    createAndApprove: "Create and Approve",
    createdAndApproved: "Leave request created and approved",
    created: "Leave request created",
    fillRequired: "Please fill in all required fields",
    selectUser: "Select User",
    create: "Create",
  },
  myFinance: {
    title: "My Finances",
    subtitle: "Your advances, POT, charging allowance and other records",
    hiddenTitle: "Finance data currently hidden",
    hiddenDesc: "Your firm admin has turned off employee finance visibility. Please contact your administrator for details.",
    savePdf: "Save as PDF",
  },
  workStats: {
    myStatistics: "My Work Statistics",
    myStatisticsDesc: "Yearly work status overview",
    adminStatistics: "Work Statistics",
    employeeStatistics: "Employee Statistics",
    adminStatisticsDesc: "All employees' status statistics",
    monthlyBreakdown: "Monthly Breakdown",
    statusDistribution: "Status Distribution",
    calendarView: "Calendar View",
    employeeBreakdown: "Employee Breakdown",
    yearSummary: "Year Summary",
    periodSummary: "Period Summary",
    totalRecords: "total of",
    daysRecorded: "days recorded",
    periodTotal: "period total of",
    recordsFound: "records found",
    employeesTracked: "employees tracked",
    quickRange: "Quick Range",
    today: "Today",
    yesterday: "Yesterday",
    thisWeek: "This Week",
    lastWeek: "Last Week",
    thisMonth: "This Month",
    thisQuarter: "This Quarter",
    thisYear: "This Year",
    dateRange: "Date Range",
    year: "Year",
    startDate: "Start Date",
    endDate: "End Date",
    exportExcel: "Export Excel",
    exportSuccess: "Excel file downloaded",
    externalFirm: "External Firm",
    lastMonth: "Last Month",
  },
  employeeProfile: {
    title: "Employee Profiles",
    myProfile: "My Profile",
    personalInfo: "Personal Information",
    documents: "Documents",
    history: "Leave & Work History",
    finance: "Finance & Statistics",
    profileCompletion: "Profile Completion",
    complete: "Complete",
    incomplete: "Incomplete",
    saveProfile: "Save",
    uploadDocument: "Upload Document",
    addFinanceEntry: "Add Finance Entry",
    type: "Type",
    myDocuments: "My Documents",
    employeeDocuments: "Employee Documents",
    documentsOf: "Documents",
    firstName: "First Name",
    lastName: "Last Name",
    birthDate: "Date of Birth",
    birthPlace: "Place of Birth",
    nationality: "Nationality",
    nationalId: "National ID",
    maritalStatus: "Marital Status",
    bloodType: "Blood Type",
    idExpiryDate: "ID Card Expiry Date",
    licenseExpiryDate: "Driver's License Expiry Date",
    ocrHint: "Auto-filled when uploading document",
    ocrProcessing: "Scanning document, extracting dates...",
    ocrExpiryFound: "Expiry date found",
    ocrDatesFound: "Dates found",
    ocrNoDateFound: "No date found in document. Please enter manually.",
    ocrError: "OCR scan error",
    documentEditor: {
      dragDropTitle: "Drag and drop the document",
      supportedFormats: "JPG, PNG, WEBP, PDF supported",
      selectFile: "Select File",
      pasteFromClipboard: "Paste from Clipboard",
      pasteHint: "Press Ctrl+V to paste directly from clipboard",
      rotateLeft: "Rotate Left",
      rotateRight: "Rotate Right",
      flipHorizontal: "Flip Horizontal",
      flipVertical: "Flip Vertical",
      reset: "Reset",
      changeImage: "Select Different Image",
      skipEdit: "Upload Without Editing",
      cropAndUpload: "Crop and Upload",
      applyChanges: "Apply Changes",
      cancel: "Cancel",
      crop: "Crop",
      edit: "Edit",
      editing: "Editing",
      readyToUpload: "Ready to Upload",
      rotate: "Rotate",
      zoom: "Zoom",
      zoomIn: "Zoom In",
      zoomOut: "Zoom Out",
      deleteConfirm: "Are you sure you want to delete this document?",
      deleteDocument: "Delete Document",
      deleteSuccess: "Document deleted successfully",
      processing: "Processing...",
      save: "Save",
      saveAndUpload: "Save and Upload",
    },
    expiringDocuments: "Expiring Documents",
    expiringDocumentsDesc: "Employees with documents nearing expiry",
    daysRemaining: "days remaining",
    expired: "Expired",
    noExpiringDocuments: "No expiring documents",
    cropAndEdit: "Crop and Upload",
    ocrResults: "OCR Scan Results",
    ocrResultsDesc: "The following dates were extracted from the document. Confirm to apply to the form.",
    applyDates: "Apply Dates",
    employmentDates: "Employment Dates",
    employmentStartDate: "Employment Start Date",
    employmentEndDate: "Employment End Date",
    employmentDatesUpdated: "Employment dates updated",
    employmentDatesError: "Failed to update employment dates",
    single: "Single",
    married: "Married",
    divorced: "Divorced",
    widowed: "Widowed",
    cohabiting: "Cohabiting",
    addressInfo: "Address Information",
    street: "Street",
    houseNumber: "House No",
    postalCode: "Postal Code",
    city: "City",
    country: "Country",
    contactBankInfo: "Contact & Bank Details",
    phone: "Phone",
    emailAddress: "Email Address",
    bankAccount: "Bank Account (IBAN)",
    fiscalInfo: "Fiscal Status",
    fiscalInfoDesc: "Indicate dependents for tax purposes",
    childrenDependent: "Children as dependents",
    numberOfChildren: "Number of children",
    spouseDependent: "Spouse as dependent",
    otherDependents: "Other dependents",
    numberOfOtherDependents: "Number of persons",
    importantDocuments: "Important Documents",
    importantDocumentsDesc: "Your ID card, driver attestation and driver's license documents",
    frontSide: "Front Side",
    backSide: "Back Side",
    showFrontSide: "Show front side",
    showBackSide: "Show back side",
    noDocuments: "No documents yet",
    noDocumentsDesc: "Your administrator can assign documents to you",
    firstUpload: "Upload first document",
    documentType: "Document Type",
    documentNumber: "Document Number",
    issueDate: "Issue Date",
    expiryDate: "Expiry Date",
    notes: "Notes",
    download: "Download",
    selectFile: "Select file",
    dragDrop: "Click to upload or drag & drop",
    fileTypes: "PDF, JPG, PNG, DOC (max 10MB)",
    uploadedBy: "Uploaded by",
    date: "Date",
    idCard: "ID Card",
    passport: "Passport",
    driverLicense: "Driver's License",
    residencePermit: "Residence Permit",
    workContract: "Work Contract",
    diploma: "Diploma/Certificate",
    medicalCert: "Medical Certificate",
    bankDetails: "Bank Details",
    taxForm: "Tax Form",
    other: "Other",
    approved: "Approved",
    pending: "Pending",
    leaveDays: "Leave Days",
    workDays: "Work Days",
    recentLeaves: "Recent Leave Requests",
    approvedDates: "Approved Dates",
    noLeaves: "No leave requests",
    totalDebt: "Total Debt",
    totalPaid: "Total Paid",
    bonus: "Bonus",
    netBalance: "Net Balance",
    transactionHistory: "Transaction History",
    noTransactions: "No transactions",
    financeHidden: "Financial information hidden by administrator",
    advance: "Advance",
    debt: "Debt",
    payment: "Payment",
    deduction: "Deduction",
    bonusType: "Bonus",
    potPlus: "POT+ (Credit)",
    potMinus: "POT- (Debit)",
    laadvergoeding: "Charging Fee (Electric)",
    leasing: "Leasing",
    otherType: "Other",
    addNew: "Add New",
    amount: "Amount",
    description: "Description",
    deleteRecord: "Delete Record",
    deleteConfirm: "Are you sure you want to delete this record?",
    employeesFound: "employees found",
    searchPlaceholder: "Search by name or email...",
    allProfiles: "All Profiles",
    completeProfiles: "Complete",
    incompleteProfiles: "Incomplete",
    allFirms: "All Firms",
    avgCompletion: "Avg. Completion",
    noEmployees: "No employees found",
    exportCsv: "Export CSV",
    employee: "Employee",
    contact: "Contact",
    profile: "Profile",
    profileSaved: "Profile saved",
    profileSaveError: "Failed to save profile",
    documentUploaded: "Document uploaded",
    documentsUploaded: "documents uploaded",
    documentUploadError: "Failed to upload document",
    dragDropMultiple: "Drag and drop files here",
    orClickToSelect: "or click to select",
    clickToAddMore: "Click or drag to add more files",
    filesSelected: "files selected",
    invalidFileType: "Some files have unsupported format",
    forUpload: "upload document for",
    dropFilesHere: "Drop files here",
    filesWillBeUploaded: "Files will be uploaded",
    dragDropHint: "Tip: You can quickly upload files by dragging and dropping them into this area",
    deleteDocumentTitle: "Delete Document",
    deleteDocumentConfirm: "Are you sure you want to delete this document?",
    deleteDocumentWarning: "This action cannot be undone.",
    documentDeleted: "Document deleted",
    documentDeleteError: "Failed to delete document",
    editDocument: "Edit Document",
    documentUpdated: "Document updated",
    documentUpdateError: "Failed to update document",
    categoryHint: "Select the document category",
    currentCategory: "Current Category",
    documentSideUploaded: "uploaded",
    unsupportedFileFormat: "Unsupported file format. Please upload JPG, PNG, PDF or HEIC.",
    downloadError: "Download error",
    loadError: "Load error",
    payslipsDesc: "Your monthly payslip documents",
    noPayslips: "No payslips uploaded yet",
    noPayslipsDesc: "Your payslip documents will appear here once uploaded",
    packagesDesc: "Your package delivery data",
    noPackages: "No package data found",
    noPackagesDesc: "Package delivery data will appear here once available",
    category: "Category",
    personal: "Personal",
    company: "Company",
    back: "Back",
    uploadBtn: "Upload",
    cancelBtn: "Cancel",
    deleteBtn: "Delete",
    completeProfileTitle: "Complete Your Profile",
    completeProfileDesc: "Please fill in your profile information before continuing.",
    goToProfile: "Go to Profile",
    selectFileAndType: "Please select a file and document type",
    requiredFields: "Fill in required fields",
    addNote: "Add Note",
    addNoteDesc: "Add a private note about this employee (only admins can see)",
    notePlaceholder: "Write your note here...",
    notesList: "Notes",
    noNotes: "No notes yet",
    packagesTab: "Packages",
    today: "Today",
    yesterday: "Yesterday",
    thisWeek: "This Week",
    thisMonth: "This Month",
    thisYear: "This Year",
    allRegions: "All Regions",
    totalPackages: "Total Packages",
    workedDays: "Worked Days",
    dailyAvg: "Daily Avg.",
    region: "Region",
    totalAmount: "Total Amount",
    dailyPackageDist: "Daily Package Distribution",
    last30DaysPackages: "Package count for last 30 days",
    regionDist: "Region Distribution",
    regionDistDesc: "Package distribution by region",
    packageCount: "pcs",
    packageLabel: "Package",
    amountLabel: "Amount",
    loonbriefsTab: "Payslips",
    loonbriefsTitle: "Payslips",
    loonbriefsDesc: "uploaded payslip documents for",
    uploadedOn: "uploaded on",
    viewBtn: "View",
    downloadBtn: "Download",
    noLoonbriefs: "No payslips uploaded yet",
    noLoonbriefsDesc: "You can upload payslips for this employee from the Payslip Upload page",
    allYears: "All Years",
    selectMonth: "Select Month",
    period: "Period",
    viewProfile: "View Profile",
    applyOcrData: "Apply Data",
    ocrAllDatesHint: "Other dates found (click to select):",
    ocrResultsEditableDesc: "Dates found from OCR scan are shown below. You can correct them or enter manually if wrong.",
    addAliasPlaceholder: "Add new alias...",
    aliases: "Aliases / Secondary Names",
    aliasesDescription: "Used for payroll PDF matching. E.g: GEMALMAZ H.",
    aliasesSaved: "Aliases saved",
    aliasesTab: "Aliases",
    financeTab: "Finance",
    financeTitle: "Financial Records",
    manualEntry: "Manual Entry",
    noAliases: "No aliases defined yet",
    noFinanceRecords: "No financial records",
    ocrDetectedDates: "OCR Detected Dates",
    ocrNoResults: "No dates detected",
    removeAlias: "Remove alias",
    saveAliases: "Save Aliases",
    showAdvancedSection: "Show Advanced",
    totalAdvance: "Total Advance",
    totalRecords: "Total Records",
    changePhoto: "Change Photo",
    clickForDetails: "Click for details",
    details: "Details",
    driverLicenseDesc: "Driver's license document",
    identityCard: "Identity Card",
    identityCardDesc: "Identity card document",
    noPotEntries: "No timesheet entries",
    notUploaded: "Not uploaded",
    openInNewTab: "Open in new tab",
    otherDocuments: "Other Documents",
    passportDesc: "Passport document",
    photoUploadError: "Photo upload failed",
    photoUploaded: "Photo uploaded",
    uploadCover: "Upload Cover Photo",
    coverUploaded: "Cover photo uploaded",
    coverUploadError: "Cover upload failed",
    addJobTitle: "+ Add role / title",
    jobTitlePlaceholder: "Role / title (e.g. Super Admin)",
    addBio: "+ Add a short bio",
    bioPlaceholder: "Short bio (max 280 chars)",
    preview: "Preview",
    profilePhoto: "Profile Photo",
    upload: "Upload",
    uploadPhoto: "Upload Photo",
    uploaded: "Uploaded",
  },
  employeeTracking: {
    title: "Employee Tracking",
    description: "Track daily status of employees",
    filter: "Filter",
    searchEmployee: "Search employee...",
    noResults: "No results found",
    globalSearch: "Search user or plate...",
    clearFilter: "Clear Filter",
    employee: "Employee",
    employees: "Employees",
    all: "All",
    selectFirm: "Select firm",
    daySummary: "Day Summary",
    totalWorking: "Total Working",
    totalLeave: "Total Leave",
    totalSick: "Total Sick",
    totalDop: "Total DOP",
    noEmployeeFound: "No active employees found",
    noFilterMatch: "No employees match the selected filter criteria",
    firmsLoadError: "Failed to load firms",
    dataLoadError: "Failed to load data",
    status: {
      working: "Worked",
      halfDay: "Half Day",
      sick: "Sick",
      dop: "DOP",
      onLeave: "On Leave",
      holiday: "Holiday",
      halfSick: "Half Sick",
      saturday: "Saturday",
      paternity: "Paternity Leave",
      unknown: "Unknown",
    },
    months: {
      january: "January",
      february: "February",
      march: "March",
      april: "April",
      may: "May",
      june: "June",
      july: "July",
      august: "August",
      september: "September",
      october: "October",
      november: "November",
      december: "December",
    },
    days: {
      sun: "Sun",
      mon: "Mon",
      tue: "Tue",
      wed: "Wed",
      thu: "Thu",
      fri: "Fri",
      sat: "Sat",
    },
  },
  routes: {
    title: "Routes / Tours",
    description: "Manage daily route and tour data",
    allRoutes: "Route List",
    newRoute: "New Route",
    editRoute: "Edit Route",
    addRoute: "Add New Route",
    importExcel: "Import Excel",
    exportExcel: "Export Excel",
    recalculate: "Recalculate",
    recalculateTitle: "Recalculate All Routes",
    recalculateBody: "All existing route records' work hours and total amounts will be recalculated with the current calculation rules. Legacy incorrect records (e.g. hourly rate=0) will be fixed. This action cannot be undone.",
    customer: "Customer",
    customers: "Customers",
    multiSelect: "Multi-select",
    firm: "Firm",
    allFirms: "All Firms",
    month: "Month",
    allMonths: "All Months",
    search: "Search",
    searchPlaceholder: "Driver, plate...",
    date: "Date",
    licensePlate: "License Plate",
    driver: "Driver",
    copilot: "Co-pilot",
    routeNumber: "Route No",
    routeType: "Route Type",
    ritNumber: "Rit No",
    rit: "Rit",
    tour: "Tour",
    routeRitTour: "Route/Rit/Tour",
    place: "Place",
    startTime: "Start",
    endTime: "End",
    breakTime: "Break",
    workHours: "Work Hours",
    hourlyRate: "Hourly Rate",
    startCost: "Start Cost",
    workCost: "Work Cost",
    totalCost: "Total",
    kmStart: "Start KM",
    kmEnd: "End KM",
    kmTotal: "Total KM",
    km: "KM",
    time: "Time",
    price: "Price",
    total: "Total",
    actions: "Actions",
    edit: "Edit",
    delete: "Delete",
    save: "Save",
    cancel: "Cancel",
    close: "Close",
    selectAll: "Select All",
    deleteSelected: "Delete Selected",
    confirmDelete: "Are you sure you want to delete this record?",
    confirmBulkDelete: "Are you sure you want to delete {count} selected records?",
    noRecords: "No records found for this month",
    addFirstRecord: "Add First Record",
    records: "records",
    deleteRecords: "Delete Records",
    selectRow: "Select row",
    selectAllOnPage: "Select all on this page",
    perPage: "Per page",
    firstPage: "First page",
    previousPage: "Previous page",
    nextPage: "Next page",
    lastPage: "Last page",
    editAllFields: "Edit all fields",
    copyWithToday: "Copy (with today's date)",
    copyRecords: "record(s) copy",
    exportFiltered: "Export filtered data",
    viewAttachments: "File Attachments",
    summary: {
      totalRecords: "Total Records",
      totalHours: "Total Hours",
      totalKm: "Total KM",
      totalAmount: "Total Amount",
      perRecord: "per record avg.",
    },
    import: {
      title: "Import from Excel",
      multiSheetSupport: "Multi-Sheet Support",
      customerType: "Customer Type",
      pleaseSelectCustomer: "Please select a customer type",
      columnMapping: "Excel columns will be mapped according to selected customer type",
      firmLabel: "Firm:",
      selectFirm: "Select firm",
      required: "Required",
      dragDropFile: "Drag and drop file or click",
      dropFileHere: "Drop file here...",
      fileFormats: "CSV or Excel (.xlsx) • Multiple sheets supported",
      selectFile: "Select File",
      unsupportedFormat: "Unsupported file format. Please select .xlsx, .xls or .csv file.",
      excelLoaded: "Excel loaded",
      sheetsCount: "sheets",
      totalRows: "total rows",
      rowsRead: "rows read",
      fileReadError: "Failed to read file",
      sheetSelection: "Sheet Selection",
      sheetsSelected: "sheets selected",
      rows: "rows",
      selectDeselectAll: "Select / Deselect All",
      noData: "No data",
      preview: "Preview",
      toImport: "To Import",
      sheet: "sheet",
      selectedSheets: "Selected sheets",
      moverColumns: "Mover Excel Columns:",
      fedexColumns: "FedEx Excel Columns:",
      expressColumns: "Express Excel Columns:",
      getaxColumns: "GeTax Excel Columns:",
      optionalFields: "Optional",
      defaultRate: "default",
      startCost: "Start kost",
      notes: "Opmerkingen",
      selectCustomerType: "Select Customer Type",
      importRecords: "Import Records",
      importSheets: "Sheet",
      noDataToImport: "No data to import",
      andMore: "and",
      moreRows: "more rows (on this sheet)",
      duplicateWarning: "duplicate records skipped",
      selectSheet: "Select Sheet",
      selectCustomer: "Select Customer Type",
      customerRequired: "Please select customer type first",
      dragDrop: "Drag & drop or click",
      rowsFound: "rows found",
      import: "Import",
      importing: "Importing...",
      success: "records imported successfully",
      duplicatesSkipped: "duplicate records skipped",
      error: "Import error",
      moreRecords: "more records",
    },
    form: {
      selectDate: "Select date",
      selectDriver: "Select driver",
      selectCopilot: "Select co-pilot",
      selectVehicle: "Select vehicle",
      manualEntry: "Manual entry",
      searchEmployee: "Search employee...",
      noEmployeeFound: "No employee found",
      calculation: "Calculation",
      searchDriver: "Search driver...",
      searchCopilot: "Search co-pilot...",
      driverNotFound: "Driver not found",
      loading: "Loading...",
      customerRequired: "Customer *",
      customerCannotChange: "Customer cannot be changed while editing",
      firmRequired: "Firm *",
      selectFirm: "Select firm",
      dateRequired: "Date *",
      routeNumberLabel: "Route Number",
      routeNumberPlaceholder: "E.g.: 741",
      tourTypeRequired: "Tour Type *",
      selectTour: "Select tour",
      tourTypePlaceholder: "Enter tour type...",
      ritRequired: "Rit *",
      selectRit: "Select rit",
      enterRit: "Enter rit...",
      list: "List",
      vehiclePlateRequired: "License Plate *",
      searchPlate: "Search and select plate...",
      selectFirmFirst: "Select firm first",
      searchPlatePlaceholder: "Search plate...",
      vehicleNotFound: "Vehicle not found",
      orManualEntry: "or enter manually:",
      enterPlate: "Enter plate...",
      driverRequired: "Driver *",
      searchAndSelectDriver: "Search and select driver...",
      enterDriverName: "Driver name",
      allDrivers: "All Drivers",
      firmDrivers: "Firm Drivers",
      copilotLabel: "Co-pilot",
      searchAndSelectCopilot: "Search and select co-pilot...",
      enterCopilotName: "Co-pilot name",
      kmStartLabel: "KM Start",
      kmStartPlaceholder: "E.g.: 40447",
      kmEndLabel: "KM End",
      kmEndPlaceholder: "E.g.: 40531",
      hourlyRateLabel: "Hourly Rate (€)",
      startCostLabel: "Start Cost (€)",
      startTimeLabel: "Start Time",
      endTimeLabel: "End Time",
      breakTimeLabel: "Break Time",
      calculatedValues: "Calculated Values",
      totalKm: "Total KM:",
      workDuration: "Work Duration:",
      totalAmount: "Total Amount:",
      notesLabel: "Notes",
      notesPlaceholder: "Additional notes...",
    },
    messages: {
      saveSuccess: "Route saved",
      saveError: "Failed to save route",
      deleteSuccess: "Route deleted",
      deleteError: "Failed to delete route",
      bulkDeleteSuccess: "records deleted",
      bulkDeleteError: "Failed to delete records",
      loadError: "Failed to load data",
      exportSuccess: "records exported",
      exportError: "Export error",
      recalculated: "records recalculated",
      alreadyCorrect: "already correct",
      recalculateError: "Recalculation error",
      routeUpdated: "Route updated",
      routeAdded: "Route added",
      routeDeleted: "Route deleted",
      routeCopied: "Route copied",
      copyFailed: "Copy failed",
      errorOccurred: "An error occurred",
      updated: "Updated",
      updateError: "Update error",
      driverUpdated: "Driver updated",
      selectRecordsToDelete: "Please select records to delete",
      bulkDeleteConfirm: "{count} records will be deleted. Are you sure?",
      bulkDeleteError2: "Bulk delete error",
    },
    table: {
      clickToEdit: "Double-click cell to edit",
      hoverIcon: "pencil icon appears on hover",
      doubleClickStart: "Double-click: Start time",
      doubleClickEnd: "Double-click: End time",
    },
  },
  routeReports: {
    title: "Route Reports",
    description: "View route and tour statistics",
    customer: "Customer",
    firm: "Firm",
    allFirms: "All Firms",
    dateRange: "Date Range",
    startDate: "Start Date",
    endDate: "End Date",
    filter: "Filter",
    summary: "Summary Statistics",
    totalRoutes: "Total Routes",
    totalHours: "Total Hours",
    totalKm: "Total KM",
    totalAmount: "Total Amount",
    avgPerDay: "Daily Average",
    avgPerRoute: "Per Route Average",
    monthlyTrend: "Monthly Trend",
    weeklyTrend: "Weekly Trend",
    driverStats: "Driver Statistics",
    vehicleStats: "Vehicle Statistics",
    noData: "No data found for selected criteria",
    loadError: "Failed to load reports",
    records: "Records",
    currentPeriod: "Current Period",
    previousPeriod: "Previous Period",
    last6MonthsLabel: "Last 6 Months",
    previous6MonthsLabel: "Previous 6 Months",
    last12MonthsLabel: "Last 12 Months",
    previous12MonthsLabel: "Previous 12 Months",
    driverDetails: "Driver Details",
    routeCount: "Route Count",
    totalIncome: "Total Income",
    periodComparison: "Period Comparison",
    last6Months: "Last 6 Months vs Previous",
    last12Months: "Last 12 Months vs Previous",
    growthSummary: "Growth Summary",
    driverVehicleMatrix: "Driver-Vehicle Performance Matrix",
    driverVehicleMatrixDesc: "See how each driver performs with different vehicles",
    driver: "Driver",
    vehicleTotal: "Vehicle Total",
    showingTopDrivers: "Showing top",
    drivers: "drivers",
  },
  lockScreen: {
    sessionLocked: "Session Locked",
    sessionLockedDesc: "Session has been locked",
    unlockSession: "Session unlocked",
    passwordPlaceholder: "Enter your password...",
    authPlaceholder: "Authentication...",
    wrongPassword: "Wrong password",
    unlock: "Unlock",
    or: "or",
    logout: "Sign Out",
    lockScreen: "Lock Screen",
    inactivityMessage: "Locked due to {{minutes}} minutes of inactivity",
    inactivityShort: "{{minutes}} min inactivity",
    biometricUnlock: "Unlock with Biometric",
    biometricFailed: "Biometric authentication failed",
    biometricSuggestion: "You can register biometric unlock (fingerprint or face recognition) from your profile security settings for quick unlock.",
    biometricSecurity: "Biometric Security",
    biometricDescription: "Quickly unlock the lock screen with fingerprint or face recognition.",
    biometricRegistered: "Biometric registered successfully!",
    biometricCancelled: "Biometric registration cancelled",
    biometricDeleted: "Biometric credential deleted",
    registerBiometric: "Register Biometric",
    addAnotherDevice: "Add Another Device",
    registeredDevices: "registered device(s)",
    lastUsed: "Last used",
    registered: "Registered",
    dismiss: "Dismiss",
    idleTimeout: "Session Lock Timeout",
    idleTimeoutDesc: "Screen locks automatically after inactivity",
  },
  settings: {
    securitySettings: "Security Settings",
    lockScreenSettings: "Session locking and security settings",
    minutes: "minutes",
    idleTimeoutDescription: "The screen will automatically lock when the user is idle for the specified duration. (1-120 minutes)",
  },
  email: {
    mandrill_api_key: "Mandrill API Key",
    smtp_pass: "SMTP Password",
  },
  sms: {
    api_key: "SMS API Key",
  },
  whatsapp: {
    api_key: "WhatsApp API Key",
  },
  planning: {
    days: {
      0: "Monday", 1: "Tuesday", 2: "Wednesday", 3: "Thursday",
      4: "Friday", 5: "Saturday", 6: "Sunday"
    },
    copyDayToNext: "Copy {{day}} → {{next}}",
    spreadDayTitle: "Spread {{day}} to the remaining {{remaining}} weekdays (excl. Sunday)",
    prevWeek: "Previous week",
    nextWeek: "Next week",
    copyFromPrevWeek: "Copy from previous week",
    depotAndRoutes: "Depot & Routes",
    deleteWeekTitle: "Delete all assignments for this week",
    firmDepotRoute: "Firm / Depot / Route",
    viewConflicts: "View conflicts",
    boardCanvas: {
      title: "Planning Board",
      zoomIn: "Zoom in",
      zoomOut: "Zoom out",
      fitAll: "Fit all",
      preparing: "Preparing…",
      assignmentsCount: "{{count}} assignments",
      downloadExcelTitle: "Download styled Excel",
      open: "Open",
      noAssignmentsWeek: "No assignments this week",
      moreFirms: "+{{count}} more firms — use \"Open\" for details",
      dayCol: "Day",
      depot: "DEPOT",
      excelDownloaded: "W{{week}} styled Excel downloaded",
      downloadFailed: "Download failed",
      dataLoadFailed: "Failed to load data",
      legend: { depot: "DEPOT", assignment: "Assignment", driver: "Driver", day: "Day" },
      legendToggle: "Legend"
    }
  },
  mailArchive: {
    description: "Attachments auto-fetched by Mail Archive Rules are listed here. For PostNL distribution lists use the dedicated page.",
    searchPlaceholder: "Search file / subject / sender...",
    allRules: "All Rules",
    allFirms: "All Firms",
    allYears: "All Years",
    noRecords: "No archived files found."
  },
  dpd: {
    common: {
      firm: "Firm", date: "Date", dateFrom: "From", dateTo: "To",
      refresh: "Refresh", loading: "Loading...", noData: "No data",
      total: "Total", search: "Search...", clear: "Clear", cancel: "Cancel",
      delete: "Delete", preview: "Preview", page: "Page", pageSize: "Page size",
      first: "First", last: "Last", prev: "Prev", next: "Next",
      preset7: "Last 7 days", preset14: "Last 14 days", preset30: "Last 30 days",
      preset90: "Last 90 days", preset3: "Last 3 days",
      day: "day", tour: "Tour", courier: "Courier", subco: "Subco",
      packages: "Parcels", stops: "Stops", km: "Km", hours: "Hours",
      retour: "Retour", deliveryRate: "Delivery Rate", successRate: "Success %",
      fastTrans: "Fast-Trans", ownCompany: "Your Company", activeDays: "Active Days"
    },
    dailySummary: {
      title: "DPD Daily Summary", subtitle: "Fast-Trans DPD tours — courier, stops, parcels and distance",
      ingestFromMail: "Import from Mail Archive",
      cols: { tour: "Tour", courier: "Courier", chassis: "Plate/Chassis", stops: "Stops", parcels: "Parcels", retourPlan: "Retour Plan", km: "Km", duration: "Duration", start: "Start", end: "End", endpoint: "Endpoint" },
      stats: { tours: "Tours", totalStops: "Total Stops", delivered: "Delivered", totalKm: "Total Km", retour: "Retour" }
    },
    driverPerformance: {
      title: "DPD Driver & Tour Performance",
      subtitle: "Total parcels, delivery rate, retours and distance by {{group}} over the date range.",
      groupCourier: "By Courier", groupTour: "By Tour",
      trendTitle: "Weekly Trend (Last 8 Weeks)",
      cols: { courier: "Courier", tour: "Tour", days: "Days", tours: "Tours", couriers: "Couriers", parcels: "Parcels", stops: "Stops", retour: "Retour", deliveryPct: "Delivery %", km: "Km", hours: "Hours", avgKmDay: "Avg Km/Day" },
      colorLegend: "Color scale:",
      empty: "No data for the selected range."
    },
    consolidated: {
      title: "DPD Consolidated Daily Operations Report",
      subtitle: "Fast-Trans daily consolidated performance: line success rate, retour root causes and auto-generated management insights.",
      modeSingle: "Single Day", modeRange: "Date Range",
      kpi: {
        parcelsPlan: "Parcels Dispatched", tourSum: "Total of {{count}} lines", tourSumRange: "{{tours}} lines × {{days}} days",
        deliveredSA13: "Successful Delivery (SA13)", deliveryRatio: "Delivery: {{rate}}%",
        returnedSA23: "Failed Delivery (SA23)", returnRate: "Return: {{rate}}%",
        pickupSA15: "Picked Up (SA15)", pickupSubtitle: "Couriers' Pickups",
        ftRetour: "Fast Trans Retour", scannedOthers: "Scanned to depot ({{others}} others)",
        totalKm: "Total Km", kmPerParcel: "Avg {{v}} km/parcel",
        totalHours: "Total Work Hours", hoursPerTour: "Avg {{v}} h/line",
        activeLines: "Active Lines", activeLinesSubtitle: "Fast-Trans"
      },
      tourTableTitle: "Fast Trans — Line & Driver End-of-Day Closing Performance",
      tourCols: { date: "Date", line: "Line", driverChassis: "Driver & Chassis", plan: "Plan", sa13: "SA13", sa23: "SA23", sa15: "SA15", distance: "Distance", durationOFD: "Time (OFD)", parcelsPerHour: "Parcels/hr", endpoint: "Endpoint", successPct: "Success %" },
      reasonBreakdown: "Retour Reason Code Distribution (Fast Trans)",
      reasonCols: { code: "Code", label: "Description", count: "Count", pct: "%", chart: "Distribution" },
      retourDetayTitle: "Retour Details: Recipient, Address and Reason",
      retourDetayHeader: "({{ft}} Fast-Trans parcels{{othersText}})",
      retourOthersText: " · {{n}} other subcos",
      retourCols: { packageNo: "Parcel No.", firm: "Firm", line: "Line", recipient: "Recipient & Address", postcode: "Postcode", weight: "Kg", reason: "Root Cause", time: "Time" },
      insightsTitle: "Automated Management Insights & Actions",
      shownRange: "Showing: {{from}} - {{to}} / {{total}}",
      noTourData: "No tour data for this date."
    },
    monthlyInvoice: {
      title: "DPD Monthly Invoice Summary",
      subtitle: "Monthly parcels, product codes and premium summary per tour from Fast-Trans Subco Details files.",
      month: "Month",
      kpi: { totalParcels: "Total Parcels", reliability: "Avg Reliability", basePay: "Base Pay", netPay: "Net Payout",
             daysAndTours: "{{days}} days / {{tours}} tours", bonusMalus: "Bonus {{bonus}} / Malus {{malus}}", netSubtitle: "Base + Bonus − Malus" },
      breakdownTitle: "Monthly Distribution by Tour", productTitle: "Product Code Distribution (Monthly Total)",
      productHint: "Codes: 03D=Standard, 03XD=Extra, 03SD=Saturday, 04DAD/04DAV=Weekend, 05MAST=Master, etc.",
      cols: { tour: "Tour", activeDays: "Active Days", delivered: "Delivered", stops: "Stops", pickup: "Pickup", km: "Km", reliabilityPct: "Reliability %", basePay: "Base (€)", bonus: "Bonus", malus: "Malus", netPay: "Net (€)", totalRow: "Total" },
      empty: "No invoice data for this month. Subco Details Excels should arrive by email.",
      sourceFiles: "Source: {{files}}"
    },
    heatmap: {
      title: "DPD Retour Heatmap",
      subtitle: "Postcode (first 2 digits) × reason code matrix. Reveals problem areas and root causes.",
      subcoFilter: "Subco (optional e.g. fast)", ftOnly: "Fast-Trans Only", clearFilter: "Clear Filter",
      stats: { totalRetour: "Total Retour", pcRegion: "PC Regions", reasonCodes: "Distinct Reason Codes" },
      cols: { pcRegion: "PC / Region", total: "Total" },
      legendLow: "Low → High", legendMax: "Max: {{n}} parcels / cell", legendDensity: "Density:",
      reasonLegendTitle: "Reason Code Descriptions",
      empty: "No retour data for selected filters."
    },
    subcoComparison: {
      title: "DPD Subco Comparison",
      subtitle: "Compare Fast-Trans against other subcos for retour volume and root causes. Retour data covers all subcos; delivery & km are only available for Fast-Trans.",
      ftBlockTitle: "Fast-Trans (Your Company) — {{days}} days",
      metrics: { delivered: "Delivered", retour: "Retour", success: "Success Rate", totalKm: "Total Km" },
      stats: { totalRetour: "Total Retour", activeSubco: "Active Subcos", activeDays: "Active Days" },
      trendTitle: "Weekly Retour Trend — Top 6 Subcos",
      cols: { subco: "Subco", retour: "Retour", share: "Share %", chart: "Chart", tours: "Tours", activeDays: "Active Days", avgDay: "Avg/Day", weight: "Weight (kg)" },
      rootCauses: "Top Retour Root Causes:",
      empty: "No retour data for selected date range.",
      hint: "Click a row to see this subco's most common retour reason codes."
    },
    retourReport: {
      title: "DPD Retour Report",
      subtitle: "Undelivered parcels — server-side pagination + advanced filters",
      filters: { tour: "Tour (Q10)", subco: "Subco", reason: "Reason Code (25)", pc: "Postcode (35)", q: "Search parcel/recipient..." },
      totalPackages: "{{count}} parcels", filtered: "(filtered)", clearAll: "Clear Filters",
      aggTitle: "By {{title}} ({{count}})",
      cols: { packageNo: "Parcel No.", tour: "Tour", time: "Time", reason: "Reason", weight: "Kg", pc: "Postcode", recipient: "Recipient", subco: "Subco" },
      shownRange: "Showing: {{from}} - {{to}} / {{total}}",
      empty: "No retour records match the filters."
    },
    courierMapping: {
      title: "DPD Courier Mapping",
      subtitle: "Link the courier names in DPD RouteDataLog to real HR employees. Accept fuzzy suggestions or pick manually.",
      autoMinLabel: "Auto-match score ≥", autoApply: "Auto Apply",
      stats: { total: "Total Couriers", mapped: "Mapped", unmapped: "Unmapped" },
      cols: { courier: "DPD Courier Name", status: "Status", match: "Matched Employee / Fuzzy Suggestions", manual: "Manual Pick", action: "Action" },
      statusMapped: "Mapped", statusUnmapped: "None",
      noSuggestion: "No suggestion — pick manually",
      pickEmployee: "Pick employee...", searchPlaceholder: "Search name or email...",
      noEmployee: "No employee found.",
      remove: "Remove", empty: "No couriers found in DPD RouteDataLog.",
      hint: "💡 Fuzzy score: 100 = full name match, 50 = one part matches. Auto-apply saves {{score}}+ matches."
    },
    fileCategories: {
      title: "DPD File Categories",
      subtitle: "Browse DPD attachments by type & import per file or per category. Duplicates are auto-skipped; junk files (image, signature) are filtered.",
      ingestAll: "Import All", ingestCat: "Import This Category", deleteAll: "Delete All",
      resetAll: "Reset All Reports & Analytics", resetCat: "Reset This Category",
      resetAllTitle: "Reset all DPD data?",
      resetAllBody: "All parsed reports and analytics will be deleted (mail archive is preserved). You can then use 'Import All' to re-process the Excels.",
      resetCatTitle: "Reset the {{cat}} category?",
      resetCatBody: "All parsed rows and ingest logs for this category will be deleted. Mail archive is preserved; you can re-import.",
      resetDone: "Reset done: {{n}} records deleted",
      resetFailed: "Reset failed",
      mailDate: "Mail Date",
      totalSummary: "{{files}} files total, {{cats}} categories",
      countFiles: "{{n}} files", countIngested: "({{n}} imported)",
      cols: { file: "File", date: "Date", mailDate: "Mail Date", archived: "Archived", from: "From", status: "Status", action: "Action" },
      excludePlaceholder: "Exclude by filename (e.g. HYK, test)",
      filteredHint: "{{n}} files filtered out",
      sort: {
        mailDesc: "Mail Date (New → Old)",
        mailAsc: "Mail Date (Old → New)",
        arcDesc: "Archived (New → Old)",
        arcAsc: "Archived (Old → New)",
      },
      status: { rows: "{{n}} rows", waiting: "Waiting", junk: "Junk" },
      toast: {
        alreadyIngested: "Already imported",
        importedRows: "{{n}} rows imported",
        importFailed: "Import failed",
        bulkResult: "{{ingested}} files processed",
        bulkAlready: "{{n}} already imported", bulkJunk: "{{n}} junk skipped", bulkUnknown: "{{n}} unknown skipped", bulkErrors: "{{n}} errors",
        bulkFailed: "Bulk import failed",
        previewFailed: "Preview failed",
        deleted: "File deleted", deleteFailed: "Delete failed",
        junkDeleted: "{{done}} junk files deleted"
      },
      dialog: {
        deleteFileTitle: "Delete file?",
        deleteFileBody: "{{filename}} will be permanently deleted. This cannot be undone.",
        deleteJunkTitle: "Delete {{n}} junk files?",
        deleteJunkBody: "This cannot be undone. Files will be removed from mail archive and S3."
      },
      emptyState: "No DPD files found in mail archive yet.",
      emptyHint: "Define a rule for dpd.be under Settings → Mail Archive Rules."
    },
    alerts: {
      widgetTitle: "DPD Alerts",
      severityHigh: "high", severityMedium: "medium", severityLow: "low",
      badges: { high: "High", medium: "Medium", low: "Low" },
      types: { lowDelivery: "Low Delivery", highRetour: "High Retour" },
      detailLink: "Details →",
      moreAlerts: "+{{n}} more alerts — "
    },
    analytics: {
      title: "DPD Analytics & Insights",
      subtitle: "Fast-Trans exclusive — yearly trends, comparisons, forecasts and AI summary",
      year: "Year", refresh: "Refresh", loading: "Computing analytics…",
      empty: "No Fast-Trans data for this year. Import the Excels first.",
      kpi: {
        packages: "Total Packages", retour: "Total Retour", deliveryRate: "Delivery Rate",
        activeDays: "Active Days", activeCouriers: "Active Couriers", activeTours: "Active Tours", avgDaily: "Daily Avg",
      },
      yoy: {
        title: "Year Comparison ({{prev}} vs {{cur}})",
        packages: "Package Volume", retour: "Retour Count", deliveryRate: "Delivery Rate", couriers: "Active Couriers",
      },
      monthly: { title: "Monthly Trend", subtitle: "Last 24 months delivery / retour volume", packages: "Packages", retour: "Retour", deliveryPct: "Delivery %" },
      dow: { title: "Day-of-Week Pattern", subtitle: "Which days are critical — volume & success rate" },
      reasons: { title: "Retour Reason Trend", topTitle: "Most Frequent Retour Reasons", share: "Share" },
      drivers: {
        title: "Driver Ranking & Recommendations",
        subtitle: "Score = 60% delivery + 30% volume + 10% consistency",
        rank: "Rank", courier: "Courier", score: "Score", packages: "Packages", retour: "Retour", deliveryPct: "Delivery %", days: "Days", recommendation: "Recommendation",
      },
      forecast: {
        title: "Forecast", nextMonthRetour: "Next Month Retour Estimate", nextMonthPackages: "Expected Package Volume",
        based: "Based on last {{n}} months", trend: { up: "Rising", down: "Falling", flat: "Flat" },
      },
      insights: { title: "Automated Insights", subtitle: "Patterns extracted from the numbers" },
      ai: { title: "Analysis (Claude Sonnet)", subtitle: "Executive brief — natural language assessment", loading: "Generating analysis…", error: "Analysis unavailable" },
      pdf: { export: "Download PDF", generating: "Generating PDF…", done: "PDF ready", failed: "PDF generation failed", fileName: "DPD-Analytics-{{year}}.pdf" },
      driver: { modalTitle: "Driver Detail — {{name}}", coaching: "Personal Coaching Note", vsAvg: "vs Firm Average", rank: "Rank", personalTrend: "Personal Monthly Trend", yourReasons: "Your Retour Reasons", close: "Close", clickHint: "Click row for details" },
    }
  }
};

export default en;
